// This file is auto-generated by @hey-api/openapi-ts

import { type Options, getMETHODSLASHwelloSLASHv2SLASHauthSLASHbanner, postMETHODSLASHwelloSLASHv2SLASHauthSLASHbenefitDASHnotificationSLASHapplicationDASHinfo, getMETHODSLASHwelloSLASHv2SLASHauthSLASHbenefitDASHnotificationSLASHapplicationDASHresultsDASHurl, getMETHODSLASHwelloSLASHv2SLASHauthSLASHbenefitDASHnotificationSLASHfitDASHanalysis, getMETHODSLASHwelloSLASHv2SLASHauthSLASHbenefitDASHnotificationSLASHfitDASHanalysisDASHresult, getMETHODSLASHwelloSLASHv2SLASHauthSLASHbenefitDASHnotificationSLASHmainDASHinfo, getMETHODSLASHwelloSLASHv2SLASHauthSLASHbenefitDASHnotificationSLASHprivacyDASHpolicyDASHurl, getMETHODSLASHwelloSLASHv2SLASHauthSLASHbenefitDASHnotificationSLASHprivacyDASHusageDASHurl, getMETHODSLASHwelloSLASHv2SLASHauthSLASHbenefitDASHnotificationSLASHpublicDASHserviceDASHdetailDASHurl, getMETHODSLASHwelloSLASHv2SLASHauthSLASHbenefitDASHnotificationSLASHserviceDASHusageDASHagreementDASHmanagementDASHurl, getMETHODSLASHwelloSLASHv2SLASHauthSLASHbenefitDASHnotificationSLASHserviceDASHusageDASHagreementDASHurl, getMETHODSLASHwelloSLASHv2SLASHauthSLASHbenefitDASHnotificationSLASHsituationDASHmanagementDASHurl, getMETHODSLASHwelloSLASHv2SLASHauthSLASHbenefitDASHnotificationSLASHtermDASHserviceDASHurl, getMETHODSLASHwelloSLASHv2SLASHauthSLASHcontentsSLASHbest, getMETHODSLASHwelloSLASHv2SLASHauthSLASHcontentsSLASHbestSLASHnew, getMETHODSLASHwelloSLASHv2SLASHauthSLASHcontentsSLASHbestSLASHpopular, getMETHODSLASHwelloSLASHv2SLASHauthSLASHcontentsSLASHbestSLASHLBRACEbestUNDERSCOREcontentsUNDERSCOREidUNDERSCOREidxRBRACE, getMETHODSLASHwelloSLASHv2SLASHauthSLASHcontentsSLASHfeedbackSLASHLBRACEbestUNDERSCOREcontentsUNDERSCOREidRBRACE, getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicyDASHcaseSLASHbabySLASHrelatedDASHpolicy, getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommonSLASHmemberDASHoauthSLASHlogout, getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommonSLASHmemberDASHoauthSLASHmyDASHinfo, getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHcategorySLASHLBRACEcommunityUNDERSCOREcategoryUNDERSCOREidRBRACESLASHpolicy, getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHlatest, getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHmy, getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHmySLASHtype, getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHfreeDASHtalk, postMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHfreeDASHtalk, getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHfreeDASHtalkSLASHfeedbackSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACE, getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHfreeDASHtalkSLASHhot, getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHfreeDASHtalkSLASHpopular, getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHfreeDASHtalkSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACE, putMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHfreeDASHtalkSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACE, putMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHfreeDASHtalkSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACESLASHdelete, deleteMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHparticipant, getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHparticipant, postMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHparticipant, putMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHparticipantSLASHinvitationDASHcheck, putMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHparticipantSLASHinvite, putMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHparticipantSLASHlift, getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHpolicyDASHtalk, postMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHpolicyDASHtalk, getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHpolicyDASHtalkSLASHfeedbackSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACE, getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHpolicyDASHtalkSLASHhot, getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHpolicyDASHtalkSLASHpolicyDASHapply, getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHpolicyDASHtalkSLASHpopular, getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHpolicyDASHtalkSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACE, putMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHpolicyDASHtalkSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACE, postMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHpolicyDASHtalkSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACESLASHcommentSLASHLBRACEcommentIdRBRACESLASHcommentDASHpick, putMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHpolicyDASHtalkSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACESLASHdelete, postMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHLBRACEcommunityUNDERSCOREidRBRACESLASHreport, postMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHvoucher, getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHvoucherSLASHfeedbackSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACE, getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHvoucherSLASHmy, putMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHvoucherSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACE, postMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHvoucherSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACESLASHcommentSLASHLBRACEcommentUNDERSCOREidRBRACESLASHcommentDASHpick, putMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHvoucherSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACESLASHdelete, getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHwelloDASHnews, getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHwelloDASHnewsSLASHfeedbackSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACE, getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHwelloDASHnewsSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACE, getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHdislike, deleteMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHdislikeSLASHLBRACEpolicyUNDERSCOREidRBRACE, postMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHdislikeSLASHLBRACEpolicyUNDERSCOREidRBRACE, getMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHgyeonggiSLASHaccount, postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHgyeonggiSLASHaccountSLASHidSLASHcheck, postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHgyeonggiSLASHaccountSLASHjoin, postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHgyeonggiSLASHaccountSLASHlogin, postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHgyeonggiSLASHaccountSLASHverification, postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHgyeonggiSLASHaccountSLASHverificationSLASHcheck, postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHaccount, postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHaccountSLASHidSLASHcheck, postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHaccountSLASHjoin, postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHaccountSLASHlogin, postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHaccountSLASHmemberDASHinfo, putMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHaccountSLASHpassword, postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHaccountSLASHpasswordDASHverification, postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHaccountSLASHpasswordDASHverificationSLASHcheck, getMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHaccountSLASHprivacyDASHpolicyDASHfirst, getMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHaccountSLASHtermsDASHofDASHservice, postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHaccountSLASHverification, postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHaccountSLASHverificationSLASHcheck, postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHappliedDASHpolicyDASHlist, postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHcltrDASHpassSLASHapply, postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHcltrDASHpassSLASHcheck, postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHisltDASHyouthDASHsprtSLASHapply, postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHisltDASHyouthDASHsprtSLASHcheck, postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHloanDASHcrdtDASHrcvrSLASHapply, postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHloanDASHcrdtDASHrcvrSLASHcheck, getMETHODSLASHwelloSLASHv2SLASHauthSLASHvoucherSLASHprovider, getMETHODSLASHwelloSLASHv2SLASHauthSLASHvoucherSLASHproviderSLASHall, getMETHODSLASHwelloSLASHv2SLASHauthSLASHvoucherSLASHproviderSLASHfeedbackSLASHLBRACEidRBRACE, getMETHODSLASHwelloSLASHv2SLASHauthSLASHvoucherSLASHproviderSLASHLBRACEproviderUNDERSCOREuuidRBRACE, getMETHODSLASHwelloSLASHv2SLASHauthSLASHemergencyDASHroom, getMETHODSLASHwelloSLASHv2SLASHauthSLASHemergencyDASHroomSLASHLBRACEemergencyRoomIdRBRACE, getMETHODSLASHwelloSLASHv2SLASHauthSLASHhometownDASHnews, getMETHODSLASHwelloSLASHv2SLASHauthSLASHhometownDASHnewsSLASHfeedbackSLASHLBRACEhometownUNDERSCOREnewsUNDERSCOREidRBRACE, getMETHODSLASHwelloSLASHv2SLASHauthSLASHhometownDASHnewsSLASHpopular, getMETHODSLASHwelloSLASHv2SLASHauthSLASHhometownDASHnewsSLASHpopularSLASHcommunity, getMETHODSLASHwelloSLASHv2SLASHauthSLASHhometownDASHnewsSLASHLBRACEhometownUNDERSCOREnewsUNDERSCOREidUNDERSCOREidxRBRACE, getMETHODSLASHwelloSLASHv2SLASHauthSLASHcsSLASHinquiry, postMETHODSLASHwelloSLASHv2SLASHauthSLASHcsSLASHinquiry, getMETHODSLASHwelloSLASHv2SLASHauthSLASHcsSLASHinquirySLASHLBRACEinquiryUNDERSCOREidRBRACE, postMETHODSLASHwelloSLASHv2SLASHauthSLASHkb, getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHaccount, postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHaccount, getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHaccountSLASHavailable, getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHcard, postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHcard, putMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHcard, putMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHcardSLASHcardDASHimage, postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHfilterSLASHfit, postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHfilterSLASHfitDASHnew, getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHfilterSLASHinterest, postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHfilterSLASHinterest, postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHfilterSLASHkb, postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHfilterSLASHregion, getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHfilterSLASHrequired, deleteMETHODSLASHwelloSLASHv2SLASHauthSLASHmember, postMETHODSLASHwelloSLASHv2SLASHauthSLASHmember, getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHactionDASHcount, getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHcontentDASHcount, getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHinterestSLASHpolicy, getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHinvitedDASHmemberDASHcount, postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHkbDASHmemberDASHcheck, putMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHmessageDASHreceive, getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHneighborSLASHpolicy, getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHpeerDASHgroupSLASHpolicy, getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHpolicySLASHprovisionDASHtypeDASHcount, getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHprofile, postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHprofile, putMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHprofile, getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHrecentSLASHpolicy, getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHrecentSLASHrecommendSLASHpolicy, getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHrecommendSLASHpolicy, deleteMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHsocialDASHaccounts, getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHsocialDASHaccounts, putMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHverification, getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHtermDASHagreement, postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHtermDASHagreement, postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHverification, getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHverificationSLASHcheck, postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHverificationSLASHdecrypt, postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHverificationSLASHinfo, postMETHODSLASHwelloSLASHv2SLASHauthSLASHniceDASHsafeDASHkey, getMETHODSLASHwelloSLASHv2SLASHauthSLASHniceDASHsafeDASHkeySLASHcheckDASHplusDASHsendDASHresult, getMETHODSLASHwelloSLASHv2SLASHauthSLASHniceDASHsafeDASHkeySLASHcheckDASHplusUNDERSCOREfail, getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHwelloSLASHblock, postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHwelloSLASHblockSLASHbyDASHcommunitySLASHLBRACEcommunityUNDERSCOREidRBRACE, deleteMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHwelloSLASHblockSLASHLBRACEblockedUNDERSCOREmemberUNDERSCOREidRBRACE, postMETHODSLASHwelloSLASHv2SLASHauthSLASHcertificationSLASHcellphone, postMETHODSLASHwelloSLASHv2SLASHauthSLASHcertificationSLASHcheck, getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHwelloSLASHlocationDASHserviceDASHconsent, putMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHwelloSLASHlocationDASHserviceDASHconsent, getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHwelloSLASHprivateUNDERSCOREdataUNDERSCOREconsent, putMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHwelloSLASHprivateUNDERSCOREdataUNDERSCOREconsent, putMETHODSLASHwelloSLASHv2SLASHauthSLASHmessageDASHrejectSLASHmemberDASHwello, getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicy, getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHfeedbackSLASHLBRACEpolicyUNDERSCOREidRBRACE, getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHinterestDASHpolicy, getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHpolicySLASHLBRACEmetaUNDERSCOREpolicyUNDERSCOREidUNDERSCOREidxRBRACESLASHrelated, getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHLBRACEmetaUNDERSCOREpolicyUNDERSCOREidUNDERSCOREidxRBRACE, getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHrecommendSLASHnearDASHexpiry, getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHrecommendSLASHnearDASHexpirySLASHprovisionDASHtypes, getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHrecommendSLASHnew, getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHrecommendSLASHnewSLASHprovisionDASHtypes, getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHrecommendSLASHtrending, getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHrecommendSLASHtrendingSLASHprovisionDASHtypes, getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHrecommendSLASHunread, getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHrecommendSLASHunreadSLASHprovisionDASHtypes, getMETHODSLASHwelloSLASHv2SLASHauthSLASHpaymentDASHhis, getMETHODSLASHwelloSLASHv2SLASHauthSLASHpaymentDASHhisSLASHtotalDASHcount, getMETHODSLASHwelloSLASHv2SLASHauthSLASHpoint, getMETHODSLASHwelloSLASHv2SLASHauthSLASHpointSLASHattendance, postMETHODSLASHwelloSLASHv2SLASHauthSLASHpointSLASHattendance, getMETHODSLASHwelloSLASHv2SLASHauthSLASHpointSLASHevent, getMETHODSLASHwelloSLASHv2SLASHauthSLASHpointSLASHhistory, postMETHODSLASHwelloSLASHv2SLASHauthSLASHpointSLASHwithdrawal, getMETHODSLASHwelloSLASHv2SLASHauthSLASHpointDASHmarketSLASHorder, postMETHODSLASHwelloSLASHv2SLASHauthSLASHpointDASHmarketSLASHorderSLASHpayments, getMETHODSLASHwelloSLASHv2SLASHauthSLASHpointDASHmarketSLASHorderSLASHpreview, postMETHODSLASHwelloSLASHv2SLASHauthSLASHpointDASHmarketSLASHorderSLASHreissueDASHcoupon, getMETHODSLASHwelloSLASHv2SLASHauthSLASHpointDASHmarketSLASHproductSLASHavailDASHpointDASHproduct, postMETHODSLASHwelloSLASHv2SLASHauthSLASHpointDASHmarketSLASHproductSLASHLBRACEproductUNDERSCOREidUNDERSCOREidxRBRACESLASHfeedback, getMETHODSLASHwelloSLASHv2SLASHauthSLASHrandomDASHticket, getMETHODSLASHwelloSLASHv2SLASHauthSLASHrandomDASHticketSLASHLBRACErandomUNDERSCOREticketUNDERSCOREidRBRACE, putMETHODSLASHwelloSLASHv2SLASHauthSLASHrandomDASHticketSLASHLBRACErandomUNDERSCOREticketUNDERSCOREidRBRACESLASHopen, putMETHODSLASHwelloSLASHv2SLASHauthSLASHrandomDASHticketSLASHLBRACErandomUNDERSCOREticketUNDERSCOREidRBRACESLASHreview, deleteMETHODSLASHwelloSLASHv2SLASHauthSLASHs3, postMETHODSLASHwelloSLASHv2SLASHauthSLASHs3, putMETHODSLASHwelloSLASHv2SLASHauthSLASHs3, postMETHODSLASHwelloSLASHv2SLASHauthSLASHs3SLASHcopy, getMETHODSLASHwelloSLASHv2SLASHauthSLASHs3SLASHdecryption, postMETHODSLASHwelloSLASHv2SLASHauthSLASHs3SLASHre, putMETHODSLASHwelloSLASHv2SLASHauthSLASHs3SLASHrename, getMETHODSLASHwelloSLASHv2SLASHauthSLASHcontentsSLASHsituation, getMETHODSLASHwelloSLASHv2SLASHauthSLASHcontentsSLASHsituationSLASHLBRACEsituationUNDERSCOREidRBRACE, getMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHappDASHpush, putMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHappDASHpush, getMETHODSLASHwelloSLASHv2SLASHauthSLASHapplyDASHpolicy, getMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHcomment, postMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHcomment, getMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHcommentSLASHlive, getMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHcommentSLASHmy, getMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHcommentSLASHLBRACEwelloCommentIdRBRACE, putMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHcommentSLASHLBRACEwelloUNDERSCOREcommentUNDERSCOREidRBRACE, putMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHcommentSLASHLBRACEwelloUNDERSCOREcommentUNDERSCOREidRBRACESLASHdelete, postMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHcommentDASHreport, postMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHdeviceDASHinfo, postMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHhelper, deleteMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHlike, postMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHlike, getMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHlikeSLASHmy, getMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHlikeSLASHmySLASHtype, deleteMETHODSLASHwelloSLASHv2SLASHauthSLASHfamily, getMETHODSLASHwelloSLASHv2SLASHauthSLASHfamilySLASHprofile, postMETHODSLASHwelloSLASHv2SLASHauthSLASHfamilySLASHprofile, putMETHODSLASHwelloSLASHv2SLASHauthSLASHfamilySLASHprofile, postMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHeventDASHparticipation, getMETHODSLASHwelloSLASHv2SLASHauthSLASHcontentsSLASHpick, getMETHODSLASHwelloSLASHv2SLASHauthSLASHcontentsSLASHpickSLASHLBRACEwelloUNDERSCOREpickUNDERSCOREidRBRACE, getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicyDASHapplySLASHcheck, getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicyDASHapplySLASHhistory, getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicyDASHapplySLASHhistorySLASHcount, postMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicyDASHapplySLASHreport, postMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHtrack, deleteMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHwishlist, postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHwishlist, getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHwishlistSLASHbestDASHcontents, getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHwishlistSLASHcommunity, getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHwishlistSLASHcommunitySLASHpolicyDASHtalk, getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHwishlistSLASHcommunitySLASHwelloDASHnews, getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHwishlistSLASHemergencyDASHroom, getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHwishlistSLASHhometownDASHnews, getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHwishlistSLASHpolicy, getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHwishlistSLASHvoucherDASHprovider } from '../sdk.gen';
import { queryOptions, type UseMutationOptions, type DefaultError, infiniteQueryOptions, type InfiniteData } from '@tanstack/react-query';
import type { GetDisplayBannerTypeUsingGetData, SaveBenefitNotificationApplicationInfoUsingPostData, SaveBenefitNotificationApplicationInfoUsingPostResponse, GetBenefitNotificationApplicationResultsUrlUsingGetData, GetBenefitNotificationFitAnalysisUsingGetData, GetBenefitNotificationFitAnalysisResultUsingGetData, GetBenefitNotificationMainInfoUsingGetData, GetBenefitNotificationPrivatePolicyUrlUsingGetData, GetBenefitNotificationPrivacyUsageUrlUsingGetData, GetBenefitNotificationPublicServiceDetailUrlUsingGetData, GetBenefitNotificationServiceUsageAgreementManagementUrlUsingGetData, GetBenefitNotificationServiceUsageAgreementUrlUsingGetData, GetBenefitNotificationSituationManagementUrlUsingGetData, GetBenefitNotificationTermServiceUrlUsingGetData, BestContentsListUsingGetData, BestContentsListUsingGetResponse, GetNewBestContentsListUsingGetData, GetPopularBestContentsListUsingGetData, BestContentsUsingGetData, BestContentsFeedbackUsingGetData, GetListChildcareRelatedPolicyUsingGetData, LogoutMemberUsingGetData, GetMemberUsingGetData, GetCommunityVoucherCategoryPolicyListUsingGetData, GetLatestCommunityListUsingGetData, GetMyCommunityListUsingGetData, GetMyCommunityListUsingGetResponse, GetMyCommunityTypeListUsingGetData, GetCommunityFreeTalkListUsingGetData, GetCommunityFreeTalkListUsingGetResponse, CreateCommunityFreeTalkUsingPostData, CreateCommunityFreeTalkUsingPostResponse, FeedbackCommunityFreeTalkUsingGetData, GetCommunityFreeTalkHotListUsingGetData, GetCommunityFreeTalkHotListUsingGetResponse, GetPopularCommunityFreeTalkListUsingGetData, GetCommunityFreeTalkUsingGetData, UpdateCommunityFreeTalkUsingPutData, UpdateCommunityFreeTalkUsingPutResponse, DeleteCommunityFreeTalkUsingPutData, DeleteCommunityFreeTalkUsingPutResponse, DeleteCommunityParticipantUsingDeleteData, DeleteCommunityParticipantUsingDeleteResponse, CheckCommunityParticipantUsingGetData, SaveCommunityParticipantUsingPostData, SaveCommunityParticipantUsingPostResponse, UpdateCommunityParticipantCheckedYnUsingPutData, UpdateCommunityParticipantCheckedYnUsingPutResponse, InviteCommunityParticipantUsingPutData, InviteCommunityParticipantUsingPutResponse, LiftCommunityParticipantUsingPutData, LiftCommunityParticipantUsingPutResponse, GetCommunityPolicyTalkListUsingGetData, GetCommunityPolicyTalkListUsingGetResponse, CreateCommunityPolicyTalkUsingPostData, CreateCommunityPolicyTalkUsingPostResponse, FeedbackCommunityPolicyTalkUsingGetData, GetCommunityPolicyTalkHotListUsingGetData, GetCommunityPolicyTalkHotListUsingGetResponse, GetCommunityPolicyTalkPolicyApplyListUsingGetData, GetPopularCommunityPolicyTalkListUsingGetData, GetCommunityPolicyTalkUsingGetData, UpdateCommunityPolicyTalkUsingPutData, UpdateCommunityPolicyTalkUsingPutResponse, SaveCommentPickUsingPostData, SaveCommentPickUsingPostResponse, DeleteCommunityPolicyTalkUsingPutData, DeleteCommunityPolicyTalkUsingPutResponse, ReportCommunityUsingPostData, ReportCommunityUsingPostResponse, SaveCommunityVoucherUsingPostData, SaveCommunityVoucherUsingPostResponse, FeedbackCommunityVoucherUsingGetData, GetMyCommunityVoucherListUsingGetData, UpdateCommunityVoucherUsingPutData, UpdateCommunityVoucherUsingPutResponse, SaveVoucherCommentPickUsingPostData, SaveVoucherCommentPickUsingPostResponse, DeleteCommunityVoucherUsingPutData, DeleteCommunityVoucherUsingPutResponse, GetCommunityWelloNewsListUsingGetData, GetCommunityWelloNewsListUsingGetResponse, FeedbackCommunityWelloNewsUsingGetData, GetCommunityWelloNewsUsingGetData, DislikeUsingGetData, RemoveWishlistUsingDeleteData, RemoveWishlistUsingDeleteResponse, SaveWishlistUsingPostData, SaveWishlistUsingPostResponse, CheckDlpGyeonggiAccountUsingGetData, CheckDlpGyeonggiAccountIdUsingPostData, CheckDlpGyeonggiAccountIdUsingPostResponse, SaveDlpGyeonggiAccountUsingPostData, SaveDlpGyeonggiAccountUsingPostResponse, LoginDlpGyeonggiAccountUsingPostData, LoginDlpGyeonggiAccountUsingPostResponse, VerifyDlpGyeonggiAccountIdentificationUsingPostData, VerifyDlpGyeonggiAccountIdentificationUsingPostResponse, CheckDlpGyeonggiAccountIdentificationUsingPostData, CheckDlpGyeonggiAccountIdentificationUsingPostResponse, GetDlpSeoulAccountAndRequestLoginUsingPostData, GetDlpSeoulAccountAndRequestLoginUsingPostResponse, RequestDlpSeoulIdCheckUsingPostData, RequestDlpSeoulIdCheckUsingPostResponse, CreateAccountUsingPostData, CreateAccountUsingPostResponse, RequestLoginUsingPostData, RequestLoginUsingPostResponse, GetDlpSeoulMemberInfoUsingPostData, GetDlpSeoulMemberInfoUsingPostResponse, ChangeMemberPasswordUsingPutData, ChangeMemberPasswordUsingPutResponse, RequestDlpSeoulVerificationForPasswordUsingPostData, RequestDlpSeoulVerificationForPasswordUsingPostResponse, RequestDlpSeoulVerificationCheckForPasswordUsingPostData, RequestDlpSeoulVerificationCheckForPasswordUsingPostResponse, GetDetailTermsOfPrivacyUsingGetData, GetDetailTermsOfServiceUsingGetData, RequestDlpSeoulVerificationUsingPostData, RequestDlpSeoulVerificationUsingPostResponse, RequestDlpSeoulVerificationCheckUsingPostData, RequestDlpSeoulVerificationCheckUsingPostResponse, GetDlpSeoulAppliedPolicyListUsingPostData, GetDlpSeoulAppliedPolicyListUsingPostResponse, GetDlpSeoulCulturePassApplyUsingPostData, GetDlpSeoulCulturePassApplyUsingPostResponse, GetDlpSeoulCltrPassCheckUsingPostData, GetDlpSeoulCltrPassCheckUsingPostResponse, GetDlpSeoulIsltYoungSprtApplyUsingPostData, GetDlpSeoulIsltYoungSprtApplyUsingPostResponse, GetDlpSeoulIsltYoungSprtCheckUsingPostData, GetDlpSeoulIsltYoungSprtCheckUsingPostResponse, GetDlpSeoulLoanCrdtRcvrApplyUsingPostData, GetDlpSeoulLoanCrdtRcvrApplyUsingPostResponse, GetDlpSeoulLoanCrdtRcvrCheckUsingPostData, GetDlpSeoulLoanCrdtRcvrCheckUsingPostResponse, GetEVoucherProviderListUsingGetData, GetEVoucherProviderListUsingGetResponse, GetEVoucherProviderListAllUsingGetData, GetEVoucherProviderListAllUsingGetResponse, GetEVoucherProviderFeedbackUsingGetData, GetEVoucherProviderUsingGetData, GetEmergencyRoomListUsingGetData, GetEmergencyRoomListUsingGetResponse, GetEmergencyRoomUsingGetData, HometownNewsListUsingGetData, HometownNewsListUsingGetResponse, HometownNewsFeedbackUsingGetData, GetPopularHometownNewsListUsingGetData, GetPopularHometownNewsListForCommunityUsingGetData, HometownNewsUsingGetData, InquiryListUsingGetData, InquiryListUsingGetResponse, SaveInquiryUsingPostData, SaveInquiryUsingPostResponse, GetInquiryUsingGetData, SendPinkeyUsingPostData, SendPinkeyUsingPostResponse, MemberAccountListUsingGetData, SaveMemberAccountUsingPostData, SaveMemberAccountUsingPostResponse, GetMemberAccountUsingGetData, MemberCardListUsingGetData, SaveMemberCardUsingPostData, SaveMemberCardUsingPostResponse, UpdateIssueAtUsingPutData, UpdateIssueAtUsingPutResponse, UploadCardImageUsingPutData, UploadCardImageUsingPutResponse, PutFitFilterUsingPostData, PutFitFilterUsingPostResponse, SaveFitFilterUsingPostData, SaveFitFilterUsingPostResponse, InterestFilterUsingGetData, SaveInterestFilterUsingPostData, SaveInterestFilterUsingPostResponse, SaveKbFilterUsingPostData, SaveKbFilterUsingPostResponse, NoticeListUsingPostData, NoticeListUsingPostResponse, RequiredFilterUsingGetData, ResignMemberUsingDeleteData, ResignMemberUsingDeleteResponse, FileUploadUsingPostData, FileUploadUsingPostResponse, GetActionCountUsingGetData, MemberContentCountUsingGetData, MemberInterestPolicyListUsingGetData, GetInvitedMemberCountUsingGetData, KbMemberCheckUsingPostData, KbMemberCheckUsingPostResponse, MessageReceiveUsingPutData, MessageReceiveUsingPutResponse, MemberNeighborPolicyListUsingGetData, MemberPeerGroupPolicyListUsingGetData, MemberPolicyListUsingGetData, MemberUsingGetData, SaveMemberNickNameUsingPostData, SaveMemberNickNameUsingPostResponse, UpdateMemberNickNameUsingPutData, UpdateMemberNickNameUsingPutResponse, MemberRecentPolicyListUsingGetData, MemberRecommendPolicyByRecentListUsingGetData, MemberNewPolicyListUsingGetData, MemberNewPolicyListUsingGetResponse, DeleteMemberSocialAccountsUsingDeleteData, DeleteMemberSocialAccountsUsingDeleteResponse, MemberSocialAccountsUsingGetData, UpdateMemberVerificationUsingPutData, UpdateMemberVerificationUsingPutResponse, GetMemberTermAgreementByAgreementTypeUsingGetData, SaveOrUpdateMemberTermAgreementUsingPostData, SaveOrUpdateMemberTermAgreementUsingPostResponse, GetLatestCompletedCiUsingPostData, GetLatestCompletedCiUsingPostResponse, GetMemberVerificationIdUsingGetData, DecryptMemberVerificationUsingPostData, DecryptMemberVerificationUsingPostResponse, GetLatestCompletedUsingPostData, GetLatestCompletedUsingPostResponse, SendNiceSafeKeyUsingPostData, SendNiceSafeKeyUsingPostResponse, CheckPlusSendResultUsingGetData, CheckPlusFailUsingGetData, GetWelloMemberBlockListUsingGetData, GetWelloMemberBlockListUsingGetResponse, BlockWelloMemberByCommunityUsingPostData, BlockWelloMemberByCommunityUsingPostResponse, DeleteMemberWelloBlockUsingDeleteData, DeleteMemberWelloBlockUsingDeleteResponse, SendCertificationCellphoneUsingPostData, SendCertificationCellphoneUsingPostResponse, CertificationCheckUsingPostData, CertificationCheckUsingPostResponse, GetLocationServiceConsentUsingGetData, UpdateLocationServiceConsentUsingPutData, UpdateLocationServiceConsentUsingPutResponse, GetPrivateDataConsentUsingGetData, UpdatePrivateDataConsentUsingPutData, UpdatePrivateDataConsentUsingPutResponse, RejectMessageUsingPutData, RejectMessageUsingPutResponse, MetaPolicyListUsingGetData, MetaPolicyListUsingGetResponse, MetaPolicyFeedbackUsingGetData, GetInterestPolicyListUsingGetData, GetInterestPolicyListUsingGetResponse, GetRelatedMetaPolicyListUsingGetData, MetaPolicyUsingGetData, GetRecommendNearExpiryPolicyListUsingGetData, GetRecommendNearExpiryPolicyListUsingGetResponse, GetRecommendNearExpiryPolicyProvisionTypeAllListUsingGetData, GetRecommendNewPolicyListUsingGetData, GetRecommendNewPolicyListUsingGetResponse, GetRecommendNewPolicyProvisionTypeAllListUsingGetData, GetRecommendTrendingPolicyListUsingGetData, GetRecommendTrendingPolicyListUsingGetResponse, GetRecommendTrendingPolicyProvisionTypeAllListUsingGetData, GetRecommendUnreadPolicyListUsingGetData, GetRecommendUnreadPolicyListUsingGetResponse, GetRecommendUnreadPolicyProvisionTypeAllListUsingGetData, PaymentHisListUsingGetData, TotalPaymentHisListUsingGetData, GetDetailPointBalanceUsingGetData, GetListPointAttendanceUsingGetData, SaveTodayAttendanceUsingPostData, SaveTodayAttendanceUsingPostResponse, GetPointBudgetUsingGetData, GetListPointHistoryUsingGetData, GetListPointHistoryUsingGetResponse, SavePointWithdrawalUsingPostData, SavePointWithdrawalUsingPostResponse, GetPointMarketOrderListUsingGetData, GetPointMarketOrderListUsingGetResponse, PayPointMarketOrderUsingPostData, PayPointMarketOrderUsingPostResponse, GetPointMarketOrderPreviewUsingGetData, ReissueCouponUsingPostData, ReissueCouponUsingPostResponse, GetAvailablePointProductListUsingGetData, GetAvailablePointProductListUsingGetResponse, FeedbackPointMarketProductUsingPostData, FeedbackPointMarketProductUsingPostResponse, GetRandomTicketListUsingGetData, GetRandomTicketListUsingGetResponse, GetRandomTicketUsingGetData, OpenRandomTicketUsingPutData, OpenRandomTicketUsingPutResponse, ReviewRandomTicketUsingPutData, ReviewRandomTicketUsingPutResponse, FileDeleteUsingDeleteData, FileDeleteUsingDeleteResponse, FileUploadUsingPost1Data, FileUploadUsingPost1Response, UpdateFileTempSaveYnUsingPutData, UpdateFileTempSaveYnUsingPutResponse, FileCopyUsingPostData, FileCopyUsingPostResponse, FileDecryptionDownloadUsingGetData, FileReUploadUsingPostData, FileReUploadUsingPostResponse, FileRenameUsingPutData, FileRenameUsingPutResponse, SituationListUsingGetData, GetSituationPolicyListUsingGetData, GetWebWelloAppPushListUsingGetData, GetWebWelloAppPushListUsingGetResponse, UpdateWelloAppPushReadUsingPutData, UpdateWelloAppPushReadUsingPutResponse, GetWelloApplyPolicyListUsingGetData, GetWelloCommentListUsingGetData, GetWelloCommentListUsingGetResponse, SaveWelloCommentUsingPostData, SaveWelloCommentUsingPostResponse, GetLiveWelloCommentListUsingGetData, GetMyWelloCommentListUsingGetData, GetMyWelloCommentListUsingGetResponse, GetMetaPolicyCommentListUsingGetData, UpdateWelloCommentUsingPutData, UpdateWelloCommentUsingPutResponse, DeleteWelloCommentUsingPutData, DeleteWelloCommentUsingPutResponse, SaveWelloCommentReportUsingPostData, SaveWelloCommentReportUsingPostResponse, SaveWelloDeviceInfoUsingPostData, SaveWelloDeviceInfoUsingPostResponse, SaveWelloHelperUsingPostData, SaveWelloHelperUsingPostResponse, DeleteWelloLikeUsingDeleteData, DeleteWelloLikeUsingDeleteResponse, SaveWelloLikeUsingPostData, SaveWelloLikeUsingPostResponse, GetListLikeContentsUsingGetData, GetListLikeContentsUsingGetResponse, GetListLikeContentsTypeUsingGetData, DeleteWelloMemberFamilyUsingDeleteData, DeleteWelloMemberFamilyUsingDeleteResponse, GetWelloMemberFamilyUsingGetData, SaveWelloMemberFamilyUsingPostData, SaveWelloMemberFamilyUsingPostResponse, UpdateWelloMemberFamilyUsingPutData, UpdateWelloMemberFamilyUsingPutResponse, SaveWelloParticipationUsingPostData, SaveWelloParticipationUsingPostResponse, WelloPickListUsingGetData, WelloPickPolicyListUsingGetData, CheckWelloPolicyApplyUsingGetData, GetWelloPolicyApplyListUsingGetData, GetWelloPolicyApplyCountUsingGetData, SaveReportUsingPostData, SaveReportUsingPostResponse, SaveWelloTrackingUsingPostData, SaveWelloTrackingUsingPostResponse, DeleteWishlistUsingDeleteData, DeleteWishlistUsingDeleteResponse, SaveWishlistUsingPost1Data, SaveWishlistUsingPost1Response, BestContentsWishlistUsingGetData, GetCommunityWishlistUsingGetData, GetCommunityPolicyTalkWishlistUsingGetData, GetCommunityWelloNewsWishlistUsingGetData, GetEmergencyRoomWishlistUsingGetData, HometownNewsWishlistUsingGetData, MetaPolicyWishlistUsingGetData, VoucherProviderWishlistUsingGetData } from '../types.gen';
import { client as _heyApiClient } from '../client.gen';

export type QueryKey<TOptions extends Options> = [
    Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
        _id: string;
        _infinite?: boolean;
    }
];

const createQueryKey = <TOptions extends Options>(id: string, options?: TOptions, infinite?: boolean): [
    QueryKey<TOptions>[0]
] => {
    const params: QueryKey<TOptions>[0] = { _id: id, baseUrl: (options?.client ?? _heyApiClient).getConfig().baseUrl } as QueryKey<TOptions>[0];
    if (infinite) {
        params._infinite = infinite;
    }
    if (options?.body) {
        params.body = options.body;
    }
    if (options?.headers) {
        params.headers = options.headers;
    }
    if (options?.path) {
        params.path = options.path;
    }
    if (options?.query) {
        params.query = options.query;
    }
    return [
        params
    ];
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHbannerQueryKey = (options?: Options<GetDisplayBannerTypeUsingGetData>) => createQueryKey('getDisplayBannerTypeUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHbannerOptions = (options?: Options<GetDisplayBannerTypeUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHbanner({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHbannerQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHbenefitDASHnotificationSLASHapplicationDASHinfoQueryKey = (options?: Options<SaveBenefitNotificationApplicationInfoUsingPostData>) => createQueryKey('saveBenefitNotificationApplicationInfoUsingPost', options);

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHbenefitDASHnotificationSLASHapplicationDASHinfoOptions = (options?: Options<SaveBenefitNotificationApplicationInfoUsingPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHbenefitDASHnotificationSLASHapplicationDASHinfo({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postMETHODSLASHwelloSLASHv2SLASHauthSLASHbenefitDASHnotificationSLASHapplicationDASHinfoQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHbenefitDASHnotificationSLASHapplicationDASHinfoMutation = (options?: Partial<Options<SaveBenefitNotificationApplicationInfoUsingPostData>>) => {
    const mutationOptions: UseMutationOptions<SaveBenefitNotificationApplicationInfoUsingPostResponse, DefaultError, Options<SaveBenefitNotificationApplicationInfoUsingPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHbenefitDASHnotificationSLASHapplicationDASHinfo({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHbenefitDASHnotificationSLASHapplicationDASHresultsDASHurlQueryKey = (options: Options<GetBenefitNotificationApplicationResultsUrlUsingGetData>) => createQueryKey('getBenefitNotificationApplicationResultsUrlUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHbenefitDASHnotificationSLASHapplicationDASHresultsDASHurlOptions = (options: Options<GetBenefitNotificationApplicationResultsUrlUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHbenefitDASHnotificationSLASHapplicationDASHresultsDASHurl({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHbenefitDASHnotificationSLASHapplicationDASHresultsDASHurlQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHbenefitDASHnotificationSLASHfitDASHanalysisQueryKey = (options?: Options<GetBenefitNotificationFitAnalysisUsingGetData>) => createQueryKey('getBenefitNotificationFitAnalysisUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHbenefitDASHnotificationSLASHfitDASHanalysisOptions = (options?: Options<GetBenefitNotificationFitAnalysisUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHbenefitDASHnotificationSLASHfitDASHanalysis({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHbenefitDASHnotificationSLASHfitDASHanalysisQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHbenefitDASHnotificationSLASHfitDASHanalysisDASHresultQueryKey = (options?: Options<GetBenefitNotificationFitAnalysisResultUsingGetData>) => createQueryKey('getBenefitNotificationFitAnalysisResultUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHbenefitDASHnotificationSLASHfitDASHanalysisDASHresultOptions = (options?: Options<GetBenefitNotificationFitAnalysisResultUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHbenefitDASHnotificationSLASHfitDASHanalysisDASHresult({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHbenefitDASHnotificationSLASHfitDASHanalysisDASHresultQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHbenefitDASHnotificationSLASHmainDASHinfoQueryKey = (options?: Options<GetBenefitNotificationMainInfoUsingGetData>) => createQueryKey('getBenefitNotificationMainInfoUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHbenefitDASHnotificationSLASHmainDASHinfoOptions = (options?: Options<GetBenefitNotificationMainInfoUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHbenefitDASHnotificationSLASHmainDASHinfo({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHbenefitDASHnotificationSLASHmainDASHinfoQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHbenefitDASHnotificationSLASHprivacyDASHpolicyDASHurlQueryKey = (options: Options<GetBenefitNotificationPrivatePolicyUrlUsingGetData>) => createQueryKey('getBenefitNotificationPrivatePolicyUrlUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHbenefitDASHnotificationSLASHprivacyDASHpolicyDASHurlOptions = (options: Options<GetBenefitNotificationPrivatePolicyUrlUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHbenefitDASHnotificationSLASHprivacyDASHpolicyDASHurl({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHbenefitDASHnotificationSLASHprivacyDASHpolicyDASHurlQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHbenefitDASHnotificationSLASHprivacyDASHusageDASHurlQueryKey = (options: Options<GetBenefitNotificationPrivacyUsageUrlUsingGetData>) => createQueryKey('getBenefitNotificationPrivacyUsageUrlUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHbenefitDASHnotificationSLASHprivacyDASHusageDASHurlOptions = (options: Options<GetBenefitNotificationPrivacyUsageUrlUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHbenefitDASHnotificationSLASHprivacyDASHusageDASHurl({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHbenefitDASHnotificationSLASHprivacyDASHusageDASHurlQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHbenefitDASHnotificationSLASHpublicDASHserviceDASHdetailDASHurlQueryKey = (options: Options<GetBenefitNotificationPublicServiceDetailUrlUsingGetData>) => createQueryKey('getBenefitNotificationPublicServiceDetailUrlUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHbenefitDASHnotificationSLASHpublicDASHserviceDASHdetailDASHurlOptions = (options: Options<GetBenefitNotificationPublicServiceDetailUrlUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHbenefitDASHnotificationSLASHpublicDASHserviceDASHdetailDASHurl({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHbenefitDASHnotificationSLASHpublicDASHserviceDASHdetailDASHurlQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHbenefitDASHnotificationSLASHserviceDASHusageDASHagreementDASHmanagementDASHurlQueryKey = (options: Options<GetBenefitNotificationServiceUsageAgreementManagementUrlUsingGetData>) => createQueryKey('getBenefitNotificationServiceUsageAgreementManagementUrlUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHbenefitDASHnotificationSLASHserviceDASHusageDASHagreementDASHmanagementDASHurlOptions = (options: Options<GetBenefitNotificationServiceUsageAgreementManagementUrlUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHbenefitDASHnotificationSLASHserviceDASHusageDASHagreementDASHmanagementDASHurl({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHbenefitDASHnotificationSLASHserviceDASHusageDASHagreementDASHmanagementDASHurlQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHbenefitDASHnotificationSLASHserviceDASHusageDASHagreementDASHurlQueryKey = (options: Options<GetBenefitNotificationServiceUsageAgreementUrlUsingGetData>) => createQueryKey('getBenefitNotificationServiceUsageAgreementUrlUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHbenefitDASHnotificationSLASHserviceDASHusageDASHagreementDASHurlOptions = (options: Options<GetBenefitNotificationServiceUsageAgreementUrlUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHbenefitDASHnotificationSLASHserviceDASHusageDASHagreementDASHurl({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHbenefitDASHnotificationSLASHserviceDASHusageDASHagreementDASHurlQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHbenefitDASHnotificationSLASHsituationDASHmanagementDASHurlQueryKey = (options: Options<GetBenefitNotificationSituationManagementUrlUsingGetData>) => createQueryKey('getBenefitNotificationSituationManagementUrlUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHbenefitDASHnotificationSLASHsituationDASHmanagementDASHurlOptions = (options: Options<GetBenefitNotificationSituationManagementUrlUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHbenefitDASHnotificationSLASHsituationDASHmanagementDASHurl({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHbenefitDASHnotificationSLASHsituationDASHmanagementDASHurlQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHbenefitDASHnotificationSLASHtermDASHserviceDASHurlQueryKey = (options: Options<GetBenefitNotificationTermServiceUrlUsingGetData>) => createQueryKey('getBenefitNotificationTermServiceUrlUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHbenefitDASHnotificationSLASHtermDASHserviceDASHurlOptions = (options: Options<GetBenefitNotificationTermServiceUrlUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHbenefitDASHnotificationSLASHtermDASHserviceDASHurl({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHbenefitDASHnotificationSLASHtermDASHserviceDASHurlQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcontentsSLASHbestQueryKey = (options: Options<BestContentsListUsingGetData>) => createQueryKey('bestContentsListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcontentsSLASHbestOptions = (options: Options<BestContentsListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHcontentsSLASHbest({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHcontentsSLASHbestQueryKey(options)
    });
};

const createInfiniteParams = <K extends Pick<QueryKey<Options>[0], 'body' | 'headers' | 'path' | 'query'>>(queryKey: QueryKey<Options>, page: K) => {
    const params = queryKey[0];
    if (page.body) {
        params.body = {
            ...queryKey[0].body as any,
            ...page.body as any
        };
    }
    if (page.headers) {
        params.headers = {
            ...queryKey[0].headers,
            ...page.headers
        };
    }
    if (page.path) {
        params.path = {
            ...queryKey[0].path as any,
            ...page.path as any
        };
    }
    if (page.query) {
        params.query = {
            ...queryKey[0].query as any,
            ...page.query as any
        };
    }
    return params as unknown as typeof page;
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcontentsSLASHbestInfiniteQueryKey = (options: Options<BestContentsListUsingGetData>): QueryKey<Options<BestContentsListUsingGetData>> => createQueryKey('bestContentsListUsingGet', options, true);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcontentsSLASHbestInfiniteOptions = (options: Options<BestContentsListUsingGetData>) => {
    return infiniteQueryOptions<BestContentsListUsingGetResponse, DefaultError, InfiniteData<BestContentsListUsingGetResponse>, QueryKey<Options<BestContentsListUsingGetData>>, number | Pick<QueryKey<Options<BestContentsListUsingGetData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<BestContentsListUsingGetData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHcontentsSLASHbest({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHcontentsSLASHbestInfiniteQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcontentsSLASHbestSLASHnewQueryKey = (options?: Options<GetNewBestContentsListUsingGetData>) => createQueryKey('getNewBestContentsListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcontentsSLASHbestSLASHnewOptions = (options?: Options<GetNewBestContentsListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHcontentsSLASHbestSLASHnew({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHcontentsSLASHbestSLASHnewQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcontentsSLASHbestSLASHpopularQueryKey = (options?: Options<GetPopularBestContentsListUsingGetData>) => createQueryKey('getPopularBestContentsListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcontentsSLASHbestSLASHpopularOptions = (options?: Options<GetPopularBestContentsListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHcontentsSLASHbestSLASHpopular({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHcontentsSLASHbestSLASHpopularQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcontentsSLASHbestSLASHLBRACEbestUNDERSCOREcontentsUNDERSCOREidUNDERSCOREidxRBRACEQueryKey = (options: Options<BestContentsUsingGetData>) => createQueryKey('bestContentsUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcontentsSLASHbestSLASHLBRACEbestUNDERSCOREcontentsUNDERSCOREidUNDERSCOREidxRBRACEOptions = (options: Options<BestContentsUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHcontentsSLASHbestSLASHLBRACEbestUNDERSCOREcontentsUNDERSCOREidUNDERSCOREidxRBRACE({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHcontentsSLASHbestSLASHLBRACEbestUNDERSCOREcontentsUNDERSCOREidUNDERSCOREidxRBRACEQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcontentsSLASHfeedbackSLASHLBRACEbestUNDERSCOREcontentsUNDERSCOREidRBRACEQueryKey = (options: Options<BestContentsFeedbackUsingGetData>) => createQueryKey('bestContentsFeedbackUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcontentsSLASHfeedbackSLASHLBRACEbestUNDERSCOREcontentsUNDERSCOREidRBRACEOptions = (options: Options<BestContentsFeedbackUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHcontentsSLASHfeedbackSLASHLBRACEbestUNDERSCOREcontentsUNDERSCOREidRBRACE({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHcontentsSLASHfeedbackSLASHLBRACEbestUNDERSCOREcontentsUNDERSCOREidRBRACEQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicyDASHcaseSLASHbabySLASHrelatedDASHpolicyQueryKey = (options: Options<GetListChildcareRelatedPolicyUsingGetData>) => createQueryKey('getListChildcareRelatedPolicyUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicyDASHcaseSLASHbabySLASHrelatedDASHpolicyOptions = (options: Options<GetListChildcareRelatedPolicyUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicyDASHcaseSLASHbabySLASHrelatedDASHpolicy({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicyDASHcaseSLASHbabySLASHrelatedDASHpolicyQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommonSLASHmemberDASHoauthSLASHlogoutQueryKey = (options?: Options<LogoutMemberUsingGetData>) => createQueryKey('logoutMemberUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommonSLASHmemberDASHoauthSLASHlogoutOptions = (options?: Options<LogoutMemberUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommonSLASHmemberDASHoauthSLASHlogout({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommonSLASHmemberDASHoauthSLASHlogoutQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommonSLASHmemberDASHoauthSLASHmyDASHinfoQueryKey = (options?: Options<GetMemberUsingGetData>) => createQueryKey('getMemberUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommonSLASHmemberDASHoauthSLASHmyDASHinfoOptions = (options?: Options<GetMemberUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommonSLASHmemberDASHoauthSLASHmyDASHinfo({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommonSLASHmemberDASHoauthSLASHmyDASHinfoQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHcategorySLASHLBRACEcommunityUNDERSCOREcategoryUNDERSCOREidRBRACESLASHpolicyQueryKey = (options: Options<GetCommunityVoucherCategoryPolicyListUsingGetData>) => createQueryKey('getCommunityVoucherCategoryPolicyListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHcategorySLASHLBRACEcommunityUNDERSCOREcategoryUNDERSCOREidRBRACESLASHpolicyOptions = (options: Options<GetCommunityVoucherCategoryPolicyListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHcategorySLASHLBRACEcommunityUNDERSCOREcategoryUNDERSCOREidRBRACESLASHpolicy({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHcategorySLASHLBRACEcommunityUNDERSCOREcategoryUNDERSCOREidRBRACESLASHpolicyQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHlatestQueryKey = (options?: Options<GetLatestCommunityListUsingGetData>) => createQueryKey('getLatestCommunityListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHlatestOptions = (options?: Options<GetLatestCommunityListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHlatest({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHlatestQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHmyQueryKey = (options: Options<GetMyCommunityListUsingGetData>) => createQueryKey('getMyCommunityListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHmyOptions = (options: Options<GetMyCommunityListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHmy({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHmyQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHmyInfiniteQueryKey = (options: Options<GetMyCommunityListUsingGetData>): QueryKey<Options<GetMyCommunityListUsingGetData>> => createQueryKey('getMyCommunityListUsingGet', options, true);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHmyInfiniteOptions = (options: Options<GetMyCommunityListUsingGetData>) => {
    return infiniteQueryOptions<GetMyCommunityListUsingGetResponse, DefaultError, InfiniteData<GetMyCommunityListUsingGetResponse>, QueryKey<Options<GetMyCommunityListUsingGetData>>, number | Pick<QueryKey<Options<GetMyCommunityListUsingGetData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetMyCommunityListUsingGetData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHmy({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHmyInfiniteQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHmySLASHtypeQueryKey = (options?: Options<GetMyCommunityTypeListUsingGetData>) => createQueryKey('getMyCommunityTypeListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHmySLASHtypeOptions = (options?: Options<GetMyCommunityTypeListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHmySLASHtype({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHmySLASHtypeQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHfreeDASHtalkQueryKey = (options: Options<GetCommunityFreeTalkListUsingGetData>) => createQueryKey('getCommunityFreeTalkListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHfreeDASHtalkOptions = (options: Options<GetCommunityFreeTalkListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHfreeDASHtalk({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHfreeDASHtalkQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHfreeDASHtalkInfiniteQueryKey = (options: Options<GetCommunityFreeTalkListUsingGetData>): QueryKey<Options<GetCommunityFreeTalkListUsingGetData>> => createQueryKey('getCommunityFreeTalkListUsingGet', options, true);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHfreeDASHtalkInfiniteOptions = (options: Options<GetCommunityFreeTalkListUsingGetData>) => {
    return infiniteQueryOptions<GetCommunityFreeTalkListUsingGetResponse, DefaultError, InfiniteData<GetCommunityFreeTalkListUsingGetResponse>, QueryKey<Options<GetCommunityFreeTalkListUsingGetData>>, number | Pick<QueryKey<Options<GetCommunityFreeTalkListUsingGetData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetCommunityFreeTalkListUsingGetData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHfreeDASHtalk({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHfreeDASHtalkInfiniteQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHfreeDASHtalkQueryKey = (options?: Options<CreateCommunityFreeTalkUsingPostData>) => createQueryKey('createCommunityFreeTalkUsingPost', options);

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHfreeDASHtalkOptions = (options?: Options<CreateCommunityFreeTalkUsingPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHfreeDASHtalk({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHfreeDASHtalkQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHfreeDASHtalkMutation = (options?: Partial<Options<CreateCommunityFreeTalkUsingPostData>>) => {
    const mutationOptions: UseMutationOptions<CreateCommunityFreeTalkUsingPostResponse, DefaultError, Options<CreateCommunityFreeTalkUsingPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHfreeDASHtalk({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHfreeDASHtalkSLASHfeedbackSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACEQueryKey = (options: Options<FeedbackCommunityFreeTalkUsingGetData>) => createQueryKey('feedbackCommunityFreeTalkUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHfreeDASHtalkSLASHfeedbackSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACEOptions = (options: Options<FeedbackCommunityFreeTalkUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHfreeDASHtalkSLASHfeedbackSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACE({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHfreeDASHtalkSLASHfeedbackSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACEQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHfreeDASHtalkSLASHhotQueryKey = (options: Options<GetCommunityFreeTalkHotListUsingGetData>) => createQueryKey('getCommunityFreeTalkHotListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHfreeDASHtalkSLASHhotOptions = (options: Options<GetCommunityFreeTalkHotListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHfreeDASHtalkSLASHhot({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHfreeDASHtalkSLASHhotQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHfreeDASHtalkSLASHhotInfiniteQueryKey = (options: Options<GetCommunityFreeTalkHotListUsingGetData>): QueryKey<Options<GetCommunityFreeTalkHotListUsingGetData>> => createQueryKey('getCommunityFreeTalkHotListUsingGet', options, true);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHfreeDASHtalkSLASHhotInfiniteOptions = (options: Options<GetCommunityFreeTalkHotListUsingGetData>) => {
    return infiniteQueryOptions<GetCommunityFreeTalkHotListUsingGetResponse, DefaultError, InfiniteData<GetCommunityFreeTalkHotListUsingGetResponse>, QueryKey<Options<GetCommunityFreeTalkHotListUsingGetData>>, number | Pick<QueryKey<Options<GetCommunityFreeTalkHotListUsingGetData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetCommunityFreeTalkHotListUsingGetData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHfreeDASHtalkSLASHhot({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHfreeDASHtalkSLASHhotInfiniteQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHfreeDASHtalkSLASHpopularQueryKey = (options?: Options<GetPopularCommunityFreeTalkListUsingGetData>) => createQueryKey('getPopularCommunityFreeTalkListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHfreeDASHtalkSLASHpopularOptions = (options?: Options<GetPopularCommunityFreeTalkListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHfreeDASHtalkSLASHpopular({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHfreeDASHtalkSLASHpopularQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHfreeDASHtalkSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACEQueryKey = (options: Options<GetCommunityFreeTalkUsingGetData>) => createQueryKey('getCommunityFreeTalkUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHfreeDASHtalkSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACEOptions = (options: Options<GetCommunityFreeTalkUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHfreeDASHtalkSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACE({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHfreeDASHtalkSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACEQueryKey(options)
    });
};

export const putMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHfreeDASHtalkSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACEMutation = (options?: Partial<Options<UpdateCommunityFreeTalkUsingPutData>>) => {
    const mutationOptions: UseMutationOptions<UpdateCommunityFreeTalkUsingPutResponse, DefaultError, Options<UpdateCommunityFreeTalkUsingPutData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await putMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHfreeDASHtalkSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACE({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const putMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHfreeDASHtalkSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACESLASHdeleteMutation = (options?: Partial<Options<DeleteCommunityFreeTalkUsingPutData>>) => {
    const mutationOptions: UseMutationOptions<DeleteCommunityFreeTalkUsingPutResponse, DefaultError, Options<DeleteCommunityFreeTalkUsingPutData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await putMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHfreeDASHtalkSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACESLASHdelete({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const deleteMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHparticipantMutation = (options?: Partial<Options<DeleteCommunityParticipantUsingDeleteData>>) => {
    const mutationOptions: UseMutationOptions<DeleteCommunityParticipantUsingDeleteResponse, DefaultError, Options<DeleteCommunityParticipantUsingDeleteData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await deleteMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHparticipant({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHparticipantQueryKey = (options?: Options<CheckCommunityParticipantUsingGetData>) => createQueryKey('checkCommunityParticipantUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHparticipantOptions = (options?: Options<CheckCommunityParticipantUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHparticipant({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHparticipantQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHparticipantQueryKey = (options?: Options<SaveCommunityParticipantUsingPostData>) => createQueryKey('saveCommunityParticipantUsingPost', options);

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHparticipantOptions = (options?: Options<SaveCommunityParticipantUsingPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHparticipant({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHparticipantQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHparticipantMutation = (options?: Partial<Options<SaveCommunityParticipantUsingPostData>>) => {
    const mutationOptions: UseMutationOptions<SaveCommunityParticipantUsingPostResponse, DefaultError, Options<SaveCommunityParticipantUsingPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHparticipant({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const putMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHparticipantSLASHinvitationDASHcheckMutation = (options?: Partial<Options<UpdateCommunityParticipantCheckedYnUsingPutData>>) => {
    const mutationOptions: UseMutationOptions<UpdateCommunityParticipantCheckedYnUsingPutResponse, DefaultError, Options<UpdateCommunityParticipantCheckedYnUsingPutData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await putMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHparticipantSLASHinvitationDASHcheck({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const putMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHparticipantSLASHinviteMutation = (options?: Partial<Options<InviteCommunityParticipantUsingPutData>>) => {
    const mutationOptions: UseMutationOptions<InviteCommunityParticipantUsingPutResponse, DefaultError, Options<InviteCommunityParticipantUsingPutData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await putMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHparticipantSLASHinvite({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const putMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHparticipantSLASHliftMutation = (options?: Partial<Options<LiftCommunityParticipantUsingPutData>>) => {
    const mutationOptions: UseMutationOptions<LiftCommunityParticipantUsingPutResponse, DefaultError, Options<LiftCommunityParticipantUsingPutData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await putMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHparticipantSLASHlift({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHpolicyDASHtalkQueryKey = (options: Options<GetCommunityPolicyTalkListUsingGetData>) => createQueryKey('getCommunityPolicyTalkListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHpolicyDASHtalkOptions = (options: Options<GetCommunityPolicyTalkListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHpolicyDASHtalk({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHpolicyDASHtalkQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHpolicyDASHtalkInfiniteQueryKey = (options: Options<GetCommunityPolicyTalkListUsingGetData>): QueryKey<Options<GetCommunityPolicyTalkListUsingGetData>> => createQueryKey('getCommunityPolicyTalkListUsingGet', options, true);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHpolicyDASHtalkInfiniteOptions = (options: Options<GetCommunityPolicyTalkListUsingGetData>) => {
    return infiniteQueryOptions<GetCommunityPolicyTalkListUsingGetResponse, DefaultError, InfiniteData<GetCommunityPolicyTalkListUsingGetResponse>, QueryKey<Options<GetCommunityPolicyTalkListUsingGetData>>, number | Pick<QueryKey<Options<GetCommunityPolicyTalkListUsingGetData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetCommunityPolicyTalkListUsingGetData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHpolicyDASHtalk({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHpolicyDASHtalkInfiniteQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHpolicyDASHtalkQueryKey = (options?: Options<CreateCommunityPolicyTalkUsingPostData>) => createQueryKey('createCommunityPolicyTalkUsingPost', options);

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHpolicyDASHtalkOptions = (options?: Options<CreateCommunityPolicyTalkUsingPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHpolicyDASHtalk({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHpolicyDASHtalkQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHpolicyDASHtalkMutation = (options?: Partial<Options<CreateCommunityPolicyTalkUsingPostData>>) => {
    const mutationOptions: UseMutationOptions<CreateCommunityPolicyTalkUsingPostResponse, DefaultError, Options<CreateCommunityPolicyTalkUsingPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHpolicyDASHtalk({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHpolicyDASHtalkSLASHfeedbackSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACEQueryKey = (options: Options<FeedbackCommunityPolicyTalkUsingGetData>) => createQueryKey('feedbackCommunityPolicyTalkUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHpolicyDASHtalkSLASHfeedbackSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACEOptions = (options: Options<FeedbackCommunityPolicyTalkUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHpolicyDASHtalkSLASHfeedbackSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACE({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHpolicyDASHtalkSLASHfeedbackSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACEQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHpolicyDASHtalkSLASHhotQueryKey = (options: Options<GetCommunityPolicyTalkHotListUsingGetData>) => createQueryKey('getCommunityPolicyTalkHotListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHpolicyDASHtalkSLASHhotOptions = (options: Options<GetCommunityPolicyTalkHotListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHpolicyDASHtalkSLASHhot({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHpolicyDASHtalkSLASHhotQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHpolicyDASHtalkSLASHhotInfiniteQueryKey = (options: Options<GetCommunityPolicyTalkHotListUsingGetData>): QueryKey<Options<GetCommunityPolicyTalkHotListUsingGetData>> => createQueryKey('getCommunityPolicyTalkHotListUsingGet', options, true);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHpolicyDASHtalkSLASHhotInfiniteOptions = (options: Options<GetCommunityPolicyTalkHotListUsingGetData>) => {
    return infiniteQueryOptions<GetCommunityPolicyTalkHotListUsingGetResponse, DefaultError, InfiniteData<GetCommunityPolicyTalkHotListUsingGetResponse>, QueryKey<Options<GetCommunityPolicyTalkHotListUsingGetData>>, number | Pick<QueryKey<Options<GetCommunityPolicyTalkHotListUsingGetData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetCommunityPolicyTalkHotListUsingGetData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHpolicyDASHtalkSLASHhot({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHpolicyDASHtalkSLASHhotInfiniteQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHpolicyDASHtalkSLASHpolicyDASHapplyQueryKey = (options?: Options<GetCommunityPolicyTalkPolicyApplyListUsingGetData>) => createQueryKey('getCommunityPolicyTalkPolicyApplyListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHpolicyDASHtalkSLASHpolicyDASHapplyOptions = (options?: Options<GetCommunityPolicyTalkPolicyApplyListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHpolicyDASHtalkSLASHpolicyDASHapply({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHpolicyDASHtalkSLASHpolicyDASHapplyQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHpolicyDASHtalkSLASHpopularQueryKey = (options?: Options<GetPopularCommunityPolicyTalkListUsingGetData>) => createQueryKey('getPopularCommunityPolicyTalkListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHpolicyDASHtalkSLASHpopularOptions = (options?: Options<GetPopularCommunityPolicyTalkListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHpolicyDASHtalkSLASHpopular({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHpolicyDASHtalkSLASHpopularQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHpolicyDASHtalkSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACEQueryKey = (options: Options<GetCommunityPolicyTalkUsingGetData>) => createQueryKey('getCommunityPolicyTalkUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHpolicyDASHtalkSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACEOptions = (options: Options<GetCommunityPolicyTalkUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHpolicyDASHtalkSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACE({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHpolicyDASHtalkSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACEQueryKey(options)
    });
};

export const putMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHpolicyDASHtalkSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACEMutation = (options?: Partial<Options<UpdateCommunityPolicyTalkUsingPutData>>) => {
    const mutationOptions: UseMutationOptions<UpdateCommunityPolicyTalkUsingPutResponse, DefaultError, Options<UpdateCommunityPolicyTalkUsingPutData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await putMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHpolicyDASHtalkSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACE({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHpolicyDASHtalkSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACESLASHcommentSLASHLBRACEcommentIdRBRACESLASHcommentDASHpickQueryKey = (options: Options<SaveCommentPickUsingPostData>) => createQueryKey('saveCommentPickUsingPost', options);

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHpolicyDASHtalkSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACESLASHcommentSLASHLBRACEcommentIdRBRACESLASHcommentDASHpickOptions = (options: Options<SaveCommentPickUsingPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHpolicyDASHtalkSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACESLASHcommentSLASHLBRACEcommentIdRBRACESLASHcommentDASHpick({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHpolicyDASHtalkSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACESLASHcommentSLASHLBRACEcommentIdRBRACESLASHcommentDASHpickQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHpolicyDASHtalkSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACESLASHcommentSLASHLBRACEcommentIdRBRACESLASHcommentDASHpickMutation = (options?: Partial<Options<SaveCommentPickUsingPostData>>) => {
    const mutationOptions: UseMutationOptions<SaveCommentPickUsingPostResponse, DefaultError, Options<SaveCommentPickUsingPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHpolicyDASHtalkSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACESLASHcommentSLASHLBRACEcommentIdRBRACESLASHcommentDASHpick({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const putMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHpolicyDASHtalkSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACESLASHdeleteMutation = (options?: Partial<Options<DeleteCommunityPolicyTalkUsingPutData>>) => {
    const mutationOptions: UseMutationOptions<DeleteCommunityPolicyTalkUsingPutResponse, DefaultError, Options<DeleteCommunityPolicyTalkUsingPutData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await putMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHpolicyDASHtalkSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACESLASHdelete({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHLBRACEcommunityUNDERSCOREidRBRACESLASHreportQueryKey = (options: Options<ReportCommunityUsingPostData>) => createQueryKey('reportCommunityUsingPost', options);

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHLBRACEcommunityUNDERSCOREidRBRACESLASHreportOptions = (options: Options<ReportCommunityUsingPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHLBRACEcommunityUNDERSCOREidRBRACESLASHreport({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHLBRACEcommunityUNDERSCOREidRBRACESLASHreportQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHLBRACEcommunityUNDERSCOREidRBRACESLASHreportMutation = (options?: Partial<Options<ReportCommunityUsingPostData>>) => {
    const mutationOptions: UseMutationOptions<ReportCommunityUsingPostResponse, DefaultError, Options<ReportCommunityUsingPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHLBRACEcommunityUNDERSCOREidRBRACESLASHreport({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHvoucherQueryKey = (options?: Options<SaveCommunityVoucherUsingPostData>) => createQueryKey('saveCommunityVoucherUsingPost', options);

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHvoucherOptions = (options?: Options<SaveCommunityVoucherUsingPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHvoucher({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHvoucherQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHvoucherMutation = (options?: Partial<Options<SaveCommunityVoucherUsingPostData>>) => {
    const mutationOptions: UseMutationOptions<SaveCommunityVoucherUsingPostResponse, DefaultError, Options<SaveCommunityVoucherUsingPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHvoucher({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHvoucherSLASHfeedbackSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACEQueryKey = (options: Options<FeedbackCommunityVoucherUsingGetData>) => createQueryKey('feedbackCommunityVoucherUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHvoucherSLASHfeedbackSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACEOptions = (options: Options<FeedbackCommunityVoucherUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHvoucherSLASHfeedbackSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACE({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHvoucherSLASHfeedbackSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACEQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHvoucherSLASHmyQueryKey = (options?: Options<GetMyCommunityVoucherListUsingGetData>) => createQueryKey('getMyCommunityVoucherListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHvoucherSLASHmyOptions = (options?: Options<GetMyCommunityVoucherListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHvoucherSLASHmy({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHvoucherSLASHmyQueryKey(options)
    });
};

export const putMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHvoucherSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACEMutation = (options?: Partial<Options<UpdateCommunityVoucherUsingPutData>>) => {
    const mutationOptions: UseMutationOptions<UpdateCommunityVoucherUsingPutResponse, DefaultError, Options<UpdateCommunityVoucherUsingPutData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await putMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHvoucherSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACE({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHvoucherSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACESLASHcommentSLASHLBRACEcommentUNDERSCOREidRBRACESLASHcommentDASHpickQueryKey = (options: Options<SaveVoucherCommentPickUsingPostData>) => createQueryKey('saveVoucherCommentPickUsingPost', options);

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHvoucherSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACESLASHcommentSLASHLBRACEcommentUNDERSCOREidRBRACESLASHcommentDASHpickOptions = (options: Options<SaveVoucherCommentPickUsingPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHvoucherSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACESLASHcommentSLASHLBRACEcommentUNDERSCOREidRBRACESLASHcommentDASHpick({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHvoucherSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACESLASHcommentSLASHLBRACEcommentUNDERSCOREidRBRACESLASHcommentDASHpickQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHvoucherSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACESLASHcommentSLASHLBRACEcommentUNDERSCOREidRBRACESLASHcommentDASHpickMutation = (options?: Partial<Options<SaveVoucherCommentPickUsingPostData>>) => {
    const mutationOptions: UseMutationOptions<SaveVoucherCommentPickUsingPostResponse, DefaultError, Options<SaveVoucherCommentPickUsingPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHvoucherSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACESLASHcommentSLASHLBRACEcommentUNDERSCOREidRBRACESLASHcommentDASHpick({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const putMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHvoucherSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACESLASHdeleteMutation = (options?: Partial<Options<DeleteCommunityVoucherUsingPutData>>) => {
    const mutationOptions: UseMutationOptions<DeleteCommunityVoucherUsingPutResponse, DefaultError, Options<DeleteCommunityVoucherUsingPutData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await putMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHvoucherSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACESLASHdelete({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHwelloDASHnewsQueryKey = (options: Options<GetCommunityWelloNewsListUsingGetData>) => createQueryKey('getCommunityWelloNewsListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHwelloDASHnewsOptions = (options: Options<GetCommunityWelloNewsListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHwelloDASHnews({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHwelloDASHnewsQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHwelloDASHnewsInfiniteQueryKey = (options: Options<GetCommunityWelloNewsListUsingGetData>): QueryKey<Options<GetCommunityWelloNewsListUsingGetData>> => createQueryKey('getCommunityWelloNewsListUsingGet', options, true);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHwelloDASHnewsInfiniteOptions = (options: Options<GetCommunityWelloNewsListUsingGetData>) => {
    return infiniteQueryOptions<GetCommunityWelloNewsListUsingGetResponse, DefaultError, InfiniteData<GetCommunityWelloNewsListUsingGetResponse>, QueryKey<Options<GetCommunityWelloNewsListUsingGetData>>, number | Pick<QueryKey<Options<GetCommunityWelloNewsListUsingGetData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetCommunityWelloNewsListUsingGetData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHwelloDASHnews({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHwelloDASHnewsInfiniteQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHwelloDASHnewsSLASHfeedbackSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACEQueryKey = (options: Options<FeedbackCommunityWelloNewsUsingGetData>) => createQueryKey('feedbackCommunityWelloNewsUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHwelloDASHnewsSLASHfeedbackSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACEOptions = (options: Options<FeedbackCommunityWelloNewsUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHwelloDASHnewsSLASHfeedbackSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACE({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHwelloDASHnewsSLASHfeedbackSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACEQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHwelloDASHnewsSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACEQueryKey = (options: Options<GetCommunityWelloNewsUsingGetData>) => createQueryKey('getCommunityWelloNewsUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHwelloDASHnewsSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACEOptions = (options: Options<GetCommunityWelloNewsUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHwelloDASHnewsSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACE({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHcommunitySLASHwelloDASHnewsSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACEQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHdislikeQueryKey = (options?: Options<DislikeUsingGetData>) => createQueryKey('dislikeUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHdislikeOptions = (options?: Options<DislikeUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHdislike({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHdislikeQueryKey(options)
    });
};

export const deleteMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHdislikeSLASHLBRACEpolicyUNDERSCOREidRBRACEMutation = (options?: Partial<Options<RemoveWishlistUsingDeleteData>>) => {
    const mutationOptions: UseMutationOptions<RemoveWishlistUsingDeleteResponse, DefaultError, Options<RemoveWishlistUsingDeleteData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await deleteMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHdislikeSLASHLBRACEpolicyUNDERSCOREidRBRACE({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHdislikeSLASHLBRACEpolicyUNDERSCOREidRBRACEQueryKey = (options: Options<SaveWishlistUsingPostData>) => createQueryKey('saveWishlistUsingPost', options);

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHdislikeSLASHLBRACEpolicyUNDERSCOREidRBRACEOptions = (options: Options<SaveWishlistUsingPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHdislikeSLASHLBRACEpolicyUNDERSCOREidRBRACE({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHdislikeSLASHLBRACEpolicyUNDERSCOREidRBRACEQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHdislikeSLASHLBRACEpolicyUNDERSCOREidRBRACEMutation = (options?: Partial<Options<SaveWishlistUsingPostData>>) => {
    const mutationOptions: UseMutationOptions<SaveWishlistUsingPostResponse, DefaultError, Options<SaveWishlistUsingPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHdislikeSLASHLBRACEpolicyUNDERSCOREidRBRACE({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHgyeonggiSLASHaccountQueryKey = (options?: Options<CheckDlpGyeonggiAccountUsingGetData>) => createQueryKey('checkDlpGyeonggiAccountUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHgyeonggiSLASHaccountOptions = (options?: Options<CheckDlpGyeonggiAccountUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHgyeonggiSLASHaccount({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHgyeonggiSLASHaccountQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHgyeonggiSLASHaccountSLASHidSLASHcheckQueryKey = (options?: Options<CheckDlpGyeonggiAccountIdUsingPostData>) => createQueryKey('checkDlpGyeonggiAccountIdUsingPost', options);

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHgyeonggiSLASHaccountSLASHidSLASHcheckOptions = (options?: Options<CheckDlpGyeonggiAccountIdUsingPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHgyeonggiSLASHaccountSLASHidSLASHcheck({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHgyeonggiSLASHaccountSLASHidSLASHcheckQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHgyeonggiSLASHaccountSLASHidSLASHcheckMutation = (options?: Partial<Options<CheckDlpGyeonggiAccountIdUsingPostData>>) => {
    const mutationOptions: UseMutationOptions<CheckDlpGyeonggiAccountIdUsingPostResponse, DefaultError, Options<CheckDlpGyeonggiAccountIdUsingPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHgyeonggiSLASHaccountSLASHidSLASHcheck({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHgyeonggiSLASHaccountSLASHjoinQueryKey = (options?: Options<SaveDlpGyeonggiAccountUsingPostData>) => createQueryKey('saveDlpGyeonggiAccountUsingPost', options);

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHgyeonggiSLASHaccountSLASHjoinOptions = (options?: Options<SaveDlpGyeonggiAccountUsingPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHgyeonggiSLASHaccountSLASHjoin({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHgyeonggiSLASHaccountSLASHjoinQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHgyeonggiSLASHaccountSLASHjoinMutation = (options?: Partial<Options<SaveDlpGyeonggiAccountUsingPostData>>) => {
    const mutationOptions: UseMutationOptions<SaveDlpGyeonggiAccountUsingPostResponse, DefaultError, Options<SaveDlpGyeonggiAccountUsingPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHgyeonggiSLASHaccountSLASHjoin({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHgyeonggiSLASHaccountSLASHloginQueryKey = (options?: Options<LoginDlpGyeonggiAccountUsingPostData>) => createQueryKey('loginDlpGyeonggiAccountUsingPost', options);

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHgyeonggiSLASHaccountSLASHloginOptions = (options?: Options<LoginDlpGyeonggiAccountUsingPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHgyeonggiSLASHaccountSLASHlogin({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHgyeonggiSLASHaccountSLASHloginQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHgyeonggiSLASHaccountSLASHloginMutation = (options?: Partial<Options<LoginDlpGyeonggiAccountUsingPostData>>) => {
    const mutationOptions: UseMutationOptions<LoginDlpGyeonggiAccountUsingPostResponse, DefaultError, Options<LoginDlpGyeonggiAccountUsingPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHgyeonggiSLASHaccountSLASHlogin({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHgyeonggiSLASHaccountSLASHverificationQueryKey = (options?: Options<VerifyDlpGyeonggiAccountIdentificationUsingPostData>) => createQueryKey('verifyDlpGyeonggiAccountIdentificationUsingPost', options);

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHgyeonggiSLASHaccountSLASHverificationOptions = (options?: Options<VerifyDlpGyeonggiAccountIdentificationUsingPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHgyeonggiSLASHaccountSLASHverification({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHgyeonggiSLASHaccountSLASHverificationQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHgyeonggiSLASHaccountSLASHverificationMutation = (options?: Partial<Options<VerifyDlpGyeonggiAccountIdentificationUsingPostData>>) => {
    const mutationOptions: UseMutationOptions<VerifyDlpGyeonggiAccountIdentificationUsingPostResponse, DefaultError, Options<VerifyDlpGyeonggiAccountIdentificationUsingPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHgyeonggiSLASHaccountSLASHverification({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHgyeonggiSLASHaccountSLASHverificationSLASHcheckQueryKey = (options?: Options<CheckDlpGyeonggiAccountIdentificationUsingPostData>) => createQueryKey('checkDlpGyeonggiAccountIdentificationUsingPost', options);

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHgyeonggiSLASHaccountSLASHverificationSLASHcheckOptions = (options?: Options<CheckDlpGyeonggiAccountIdentificationUsingPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHgyeonggiSLASHaccountSLASHverificationSLASHcheck({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHgyeonggiSLASHaccountSLASHverificationSLASHcheckQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHgyeonggiSLASHaccountSLASHverificationSLASHcheckMutation = (options?: Partial<Options<CheckDlpGyeonggiAccountIdentificationUsingPostData>>) => {
    const mutationOptions: UseMutationOptions<CheckDlpGyeonggiAccountIdentificationUsingPostResponse, DefaultError, Options<CheckDlpGyeonggiAccountIdentificationUsingPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHgyeonggiSLASHaccountSLASHverificationSLASHcheck({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHaccountQueryKey = (options?: Options<GetDlpSeoulAccountAndRequestLoginUsingPostData>) => createQueryKey('getDlpSeoulAccountAndRequestLoginUsingPost', options);

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHaccountOptions = (options?: Options<GetDlpSeoulAccountAndRequestLoginUsingPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHaccount({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHaccountQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHaccountMutation = (options?: Partial<Options<GetDlpSeoulAccountAndRequestLoginUsingPostData>>) => {
    const mutationOptions: UseMutationOptions<GetDlpSeoulAccountAndRequestLoginUsingPostResponse, DefaultError, Options<GetDlpSeoulAccountAndRequestLoginUsingPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHaccount({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHaccountSLASHidSLASHcheckQueryKey = (options?: Options<RequestDlpSeoulIdCheckUsingPostData>) => createQueryKey('requestDlpSeoulIdCheckUsingPost', options);

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHaccountSLASHidSLASHcheckOptions = (options?: Options<RequestDlpSeoulIdCheckUsingPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHaccountSLASHidSLASHcheck({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHaccountSLASHidSLASHcheckQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHaccountSLASHidSLASHcheckMutation = (options?: Partial<Options<RequestDlpSeoulIdCheckUsingPostData>>) => {
    const mutationOptions: UseMutationOptions<RequestDlpSeoulIdCheckUsingPostResponse, DefaultError, Options<RequestDlpSeoulIdCheckUsingPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHaccountSLASHidSLASHcheck({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHaccountSLASHjoinQueryKey = (options?: Options<CreateAccountUsingPostData>) => createQueryKey('createAccountUsingPost', options);

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHaccountSLASHjoinOptions = (options?: Options<CreateAccountUsingPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHaccountSLASHjoin({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHaccountSLASHjoinQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHaccountSLASHjoinMutation = (options?: Partial<Options<CreateAccountUsingPostData>>) => {
    const mutationOptions: UseMutationOptions<CreateAccountUsingPostResponse, DefaultError, Options<CreateAccountUsingPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHaccountSLASHjoin({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHaccountSLASHloginQueryKey = (options?: Options<RequestLoginUsingPostData>) => createQueryKey('requestLoginUsingPost', options);

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHaccountSLASHloginOptions = (options?: Options<RequestLoginUsingPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHaccountSLASHlogin({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHaccountSLASHloginQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHaccountSLASHloginMutation = (options?: Partial<Options<RequestLoginUsingPostData>>) => {
    const mutationOptions: UseMutationOptions<RequestLoginUsingPostResponse, DefaultError, Options<RequestLoginUsingPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHaccountSLASHlogin({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHaccountSLASHmemberDASHinfoQueryKey = (options?: Options<GetDlpSeoulMemberInfoUsingPostData>) => createQueryKey('getDlpSeoulMemberInfoUsingPost', options);

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHaccountSLASHmemberDASHinfoOptions = (options?: Options<GetDlpSeoulMemberInfoUsingPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHaccountSLASHmemberDASHinfo({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHaccountSLASHmemberDASHinfoQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHaccountSLASHmemberDASHinfoMutation = (options?: Partial<Options<GetDlpSeoulMemberInfoUsingPostData>>) => {
    const mutationOptions: UseMutationOptions<GetDlpSeoulMemberInfoUsingPostResponse, DefaultError, Options<GetDlpSeoulMemberInfoUsingPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHaccountSLASHmemberDASHinfo({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const putMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHaccountSLASHpasswordMutation = (options?: Partial<Options<ChangeMemberPasswordUsingPutData>>) => {
    const mutationOptions: UseMutationOptions<ChangeMemberPasswordUsingPutResponse, DefaultError, Options<ChangeMemberPasswordUsingPutData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await putMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHaccountSLASHpassword({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHaccountSLASHpasswordDASHverificationQueryKey = (options?: Options<RequestDlpSeoulVerificationForPasswordUsingPostData>) => createQueryKey('requestDlpSeoulVerificationForPasswordUsingPost', options);

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHaccountSLASHpasswordDASHverificationOptions = (options?: Options<RequestDlpSeoulVerificationForPasswordUsingPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHaccountSLASHpasswordDASHverification({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHaccountSLASHpasswordDASHverificationQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHaccountSLASHpasswordDASHverificationMutation = (options?: Partial<Options<RequestDlpSeoulVerificationForPasswordUsingPostData>>) => {
    const mutationOptions: UseMutationOptions<RequestDlpSeoulVerificationForPasswordUsingPostResponse, DefaultError, Options<RequestDlpSeoulVerificationForPasswordUsingPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHaccountSLASHpasswordDASHverification({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHaccountSLASHpasswordDASHverificationSLASHcheckQueryKey = (options?: Options<RequestDlpSeoulVerificationCheckForPasswordUsingPostData>) => createQueryKey('requestDlpSeoulVerificationCheckForPasswordUsingPost', options);

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHaccountSLASHpasswordDASHverificationSLASHcheckOptions = (options?: Options<RequestDlpSeoulVerificationCheckForPasswordUsingPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHaccountSLASHpasswordDASHverificationSLASHcheck({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHaccountSLASHpasswordDASHverificationSLASHcheckQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHaccountSLASHpasswordDASHverificationSLASHcheckMutation = (options?: Partial<Options<RequestDlpSeoulVerificationCheckForPasswordUsingPostData>>) => {
    const mutationOptions: UseMutationOptions<RequestDlpSeoulVerificationCheckForPasswordUsingPostResponse, DefaultError, Options<RequestDlpSeoulVerificationCheckForPasswordUsingPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHaccountSLASHpasswordDASHverificationSLASHcheck({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHaccountSLASHprivacyDASHpolicyDASHfirstQueryKey = (options?: Options<GetDetailTermsOfPrivacyUsingGetData>) => createQueryKey('getDetailTermsOfPrivacyUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHaccountSLASHprivacyDASHpolicyDASHfirstOptions = (options?: Options<GetDetailTermsOfPrivacyUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHaccountSLASHprivacyDASHpolicyDASHfirst({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHaccountSLASHprivacyDASHpolicyDASHfirstQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHaccountSLASHtermsDASHofDASHserviceQueryKey = (options?: Options<GetDetailTermsOfServiceUsingGetData>) => createQueryKey('getDetailTermsOfServiceUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHaccountSLASHtermsDASHofDASHserviceOptions = (options?: Options<GetDetailTermsOfServiceUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHaccountSLASHtermsDASHofDASHservice({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHaccountSLASHtermsDASHofDASHserviceQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHaccountSLASHverificationQueryKey = (options?: Options<RequestDlpSeoulVerificationUsingPostData>) => createQueryKey('requestDlpSeoulVerificationUsingPost', options);

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHaccountSLASHverificationOptions = (options?: Options<RequestDlpSeoulVerificationUsingPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHaccountSLASHverification({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHaccountSLASHverificationQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHaccountSLASHverificationMutation = (options?: Partial<Options<RequestDlpSeoulVerificationUsingPostData>>) => {
    const mutationOptions: UseMutationOptions<RequestDlpSeoulVerificationUsingPostResponse, DefaultError, Options<RequestDlpSeoulVerificationUsingPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHaccountSLASHverification({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHaccountSLASHverificationSLASHcheckQueryKey = (options?: Options<RequestDlpSeoulVerificationCheckUsingPostData>) => createQueryKey('requestDlpSeoulVerificationCheckUsingPost', options);

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHaccountSLASHverificationSLASHcheckOptions = (options?: Options<RequestDlpSeoulVerificationCheckUsingPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHaccountSLASHverificationSLASHcheck({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHaccountSLASHverificationSLASHcheckQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHaccountSLASHverificationSLASHcheckMutation = (options?: Partial<Options<RequestDlpSeoulVerificationCheckUsingPostData>>) => {
    const mutationOptions: UseMutationOptions<RequestDlpSeoulVerificationCheckUsingPostResponse, DefaultError, Options<RequestDlpSeoulVerificationCheckUsingPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHaccountSLASHverificationSLASHcheck({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHappliedDASHpolicyDASHlistQueryKey = (options?: Options<GetDlpSeoulAppliedPolicyListUsingPostData>) => createQueryKey('getDlpSeoulAppliedPolicyListUsingPost', options);

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHappliedDASHpolicyDASHlistOptions = (options?: Options<GetDlpSeoulAppliedPolicyListUsingPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHappliedDASHpolicyDASHlist({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHappliedDASHpolicyDASHlistQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHappliedDASHpolicyDASHlistMutation = (options?: Partial<Options<GetDlpSeoulAppliedPolicyListUsingPostData>>) => {
    const mutationOptions: UseMutationOptions<GetDlpSeoulAppliedPolicyListUsingPostResponse, DefaultError, Options<GetDlpSeoulAppliedPolicyListUsingPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHappliedDASHpolicyDASHlist({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHcltrDASHpassSLASHapplyQueryKey = (options?: Options<GetDlpSeoulCulturePassApplyUsingPostData>) => createQueryKey('getDlpSeoulCulturePassApplyUsingPost', options);

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHcltrDASHpassSLASHapplyOptions = (options?: Options<GetDlpSeoulCulturePassApplyUsingPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHcltrDASHpassSLASHapply({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHcltrDASHpassSLASHapplyQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHcltrDASHpassSLASHapplyMutation = (options?: Partial<Options<GetDlpSeoulCulturePassApplyUsingPostData>>) => {
    const mutationOptions: UseMutationOptions<GetDlpSeoulCulturePassApplyUsingPostResponse, DefaultError, Options<GetDlpSeoulCulturePassApplyUsingPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHcltrDASHpassSLASHapply({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHcltrDASHpassSLASHcheckQueryKey = (options?: Options<GetDlpSeoulCltrPassCheckUsingPostData>) => createQueryKey('getDlpSeoulCltrPassCheckUsingPost', options);

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHcltrDASHpassSLASHcheckOptions = (options?: Options<GetDlpSeoulCltrPassCheckUsingPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHcltrDASHpassSLASHcheck({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHcltrDASHpassSLASHcheckQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHcltrDASHpassSLASHcheckMutation = (options?: Partial<Options<GetDlpSeoulCltrPassCheckUsingPostData>>) => {
    const mutationOptions: UseMutationOptions<GetDlpSeoulCltrPassCheckUsingPostResponse, DefaultError, Options<GetDlpSeoulCltrPassCheckUsingPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHcltrDASHpassSLASHcheck({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHisltDASHyouthDASHsprtSLASHapplyQueryKey = (options?: Options<GetDlpSeoulIsltYoungSprtApplyUsingPostData>) => createQueryKey('getDlpSeoulIsltYoungSprtApplyUsingPost', options);

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHisltDASHyouthDASHsprtSLASHapplyOptions = (options?: Options<GetDlpSeoulIsltYoungSprtApplyUsingPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHisltDASHyouthDASHsprtSLASHapply({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHisltDASHyouthDASHsprtSLASHapplyQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHisltDASHyouthDASHsprtSLASHapplyMutation = (options?: Partial<Options<GetDlpSeoulIsltYoungSprtApplyUsingPostData>>) => {
    const mutationOptions: UseMutationOptions<GetDlpSeoulIsltYoungSprtApplyUsingPostResponse, DefaultError, Options<GetDlpSeoulIsltYoungSprtApplyUsingPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHisltDASHyouthDASHsprtSLASHapply({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHisltDASHyouthDASHsprtSLASHcheckQueryKey = (options?: Options<GetDlpSeoulIsltYoungSprtCheckUsingPostData>) => createQueryKey('getDlpSeoulIsltYoungSprtCheckUsingPost', options);

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHisltDASHyouthDASHsprtSLASHcheckOptions = (options?: Options<GetDlpSeoulIsltYoungSprtCheckUsingPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHisltDASHyouthDASHsprtSLASHcheck({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHisltDASHyouthDASHsprtSLASHcheckQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHisltDASHyouthDASHsprtSLASHcheckMutation = (options?: Partial<Options<GetDlpSeoulIsltYoungSprtCheckUsingPostData>>) => {
    const mutationOptions: UseMutationOptions<GetDlpSeoulIsltYoungSprtCheckUsingPostResponse, DefaultError, Options<GetDlpSeoulIsltYoungSprtCheckUsingPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHisltDASHyouthDASHsprtSLASHcheck({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHloanDASHcrdtDASHrcvrSLASHapplyQueryKey = (options?: Options<GetDlpSeoulLoanCrdtRcvrApplyUsingPostData>) => createQueryKey('getDlpSeoulLoanCrdtRcvrApplyUsingPost', options);

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHloanDASHcrdtDASHrcvrSLASHapplyOptions = (options?: Options<GetDlpSeoulLoanCrdtRcvrApplyUsingPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHloanDASHcrdtDASHrcvrSLASHapply({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHloanDASHcrdtDASHrcvrSLASHapplyQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHloanDASHcrdtDASHrcvrSLASHapplyMutation = (options?: Partial<Options<GetDlpSeoulLoanCrdtRcvrApplyUsingPostData>>) => {
    const mutationOptions: UseMutationOptions<GetDlpSeoulLoanCrdtRcvrApplyUsingPostResponse, DefaultError, Options<GetDlpSeoulLoanCrdtRcvrApplyUsingPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHloanDASHcrdtDASHrcvrSLASHapply({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHloanDASHcrdtDASHrcvrSLASHcheckQueryKey = (options?: Options<GetDlpSeoulLoanCrdtRcvrCheckUsingPostData>) => createQueryKey('getDlpSeoulLoanCrdtRcvrCheckUsingPost', options);

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHloanDASHcrdtDASHrcvrSLASHcheckOptions = (options?: Options<GetDlpSeoulLoanCrdtRcvrCheckUsingPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHloanDASHcrdtDASHrcvrSLASHcheck({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHloanDASHcrdtDASHrcvrSLASHcheckQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHloanDASHcrdtDASHrcvrSLASHcheckMutation = (options?: Partial<Options<GetDlpSeoulLoanCrdtRcvrCheckUsingPostData>>) => {
    const mutationOptions: UseMutationOptions<GetDlpSeoulLoanCrdtRcvrCheckUsingPostResponse, DefaultError, Options<GetDlpSeoulLoanCrdtRcvrCheckUsingPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHdlpSLASHseoulSLASHloanDASHcrdtDASHrcvrSLASHcheck({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHvoucherSLASHproviderQueryKey = (options: Options<GetEVoucherProviderListUsingGetData>) => createQueryKey('getEVoucherProviderListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHvoucherSLASHproviderOptions = (options: Options<GetEVoucherProviderListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHvoucherSLASHprovider({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHvoucherSLASHproviderQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHvoucherSLASHproviderInfiniteQueryKey = (options: Options<GetEVoucherProviderListUsingGetData>): QueryKey<Options<GetEVoucherProviderListUsingGetData>> => createQueryKey('getEVoucherProviderListUsingGet', options, true);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHvoucherSLASHproviderInfiniteOptions = (options: Options<GetEVoucherProviderListUsingGetData>) => {
    return infiniteQueryOptions<GetEVoucherProviderListUsingGetResponse, DefaultError, InfiniteData<GetEVoucherProviderListUsingGetResponse>, QueryKey<Options<GetEVoucherProviderListUsingGetData>>, number | Pick<QueryKey<Options<GetEVoucherProviderListUsingGetData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetEVoucherProviderListUsingGetData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHvoucherSLASHprovider({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHvoucherSLASHproviderInfiniteQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHvoucherSLASHproviderSLASHallQueryKey = (options: Options<GetEVoucherProviderListAllUsingGetData>) => createQueryKey('getEVoucherProviderListAllUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHvoucherSLASHproviderSLASHallOptions = (options: Options<GetEVoucherProviderListAllUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHvoucherSLASHproviderSLASHall({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHvoucherSLASHproviderSLASHallQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHvoucherSLASHproviderSLASHallInfiniteQueryKey = (options: Options<GetEVoucherProviderListAllUsingGetData>): QueryKey<Options<GetEVoucherProviderListAllUsingGetData>> => createQueryKey('getEVoucherProviderListAllUsingGet', options, true);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHvoucherSLASHproviderSLASHallInfiniteOptions = (options: Options<GetEVoucherProviderListAllUsingGetData>) => {
    return infiniteQueryOptions<GetEVoucherProviderListAllUsingGetResponse, DefaultError, InfiniteData<GetEVoucherProviderListAllUsingGetResponse>, QueryKey<Options<GetEVoucherProviderListAllUsingGetData>>, number | Pick<QueryKey<Options<GetEVoucherProviderListAllUsingGetData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetEVoucherProviderListAllUsingGetData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHvoucherSLASHproviderSLASHall({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHvoucherSLASHproviderSLASHallInfiniteQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHvoucherSLASHproviderSLASHfeedbackSLASHLBRACEidRBRACEQueryKey = (options: Options<GetEVoucherProviderFeedbackUsingGetData>) => createQueryKey('getEVoucherProviderFeedbackUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHvoucherSLASHproviderSLASHfeedbackSLASHLBRACEidRBRACEOptions = (options: Options<GetEVoucherProviderFeedbackUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHvoucherSLASHproviderSLASHfeedbackSLASHLBRACEidRBRACE({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHvoucherSLASHproviderSLASHfeedbackSLASHLBRACEidRBRACEQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHvoucherSLASHproviderSLASHLBRACEproviderUNDERSCOREuuidRBRACEQueryKey = (options: Options<GetEVoucherProviderUsingGetData>) => createQueryKey('getEVoucherProviderUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHvoucherSLASHproviderSLASHLBRACEproviderUNDERSCOREuuidRBRACEOptions = (options: Options<GetEVoucherProviderUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHvoucherSLASHproviderSLASHLBRACEproviderUNDERSCOREuuidRBRACE({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHvoucherSLASHproviderSLASHLBRACEproviderUNDERSCOREuuidRBRACEQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHemergencyDASHroomQueryKey = (options: Options<GetEmergencyRoomListUsingGetData>) => createQueryKey('getEmergencyRoomListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHemergencyDASHroomOptions = (options: Options<GetEmergencyRoomListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHemergencyDASHroom({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHemergencyDASHroomQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHemergencyDASHroomInfiniteQueryKey = (options: Options<GetEmergencyRoomListUsingGetData>): QueryKey<Options<GetEmergencyRoomListUsingGetData>> => createQueryKey('getEmergencyRoomListUsingGet', options, true);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHemergencyDASHroomInfiniteOptions = (options: Options<GetEmergencyRoomListUsingGetData>) => {
    return infiniteQueryOptions<GetEmergencyRoomListUsingGetResponse, DefaultError, InfiniteData<GetEmergencyRoomListUsingGetResponse>, QueryKey<Options<GetEmergencyRoomListUsingGetData>>, number | Pick<QueryKey<Options<GetEmergencyRoomListUsingGetData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetEmergencyRoomListUsingGetData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHemergencyDASHroom({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHemergencyDASHroomInfiniteQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHemergencyDASHroomSLASHLBRACEemergencyRoomIdRBRACEQueryKey = (options: Options<GetEmergencyRoomUsingGetData>) => createQueryKey('getEmergencyRoomUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHemergencyDASHroomSLASHLBRACEemergencyRoomIdRBRACEOptions = (options: Options<GetEmergencyRoomUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHemergencyDASHroomSLASHLBRACEemergencyRoomIdRBRACE({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHemergencyDASHroomSLASHLBRACEemergencyRoomIdRBRACEQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHhometownDASHnewsQueryKey = (options: Options<HometownNewsListUsingGetData>) => createQueryKey('hometownNewsListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHhometownDASHnewsOptions = (options: Options<HometownNewsListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHhometownDASHnews({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHhometownDASHnewsQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHhometownDASHnewsInfiniteQueryKey = (options: Options<HometownNewsListUsingGetData>): QueryKey<Options<HometownNewsListUsingGetData>> => createQueryKey('hometownNewsListUsingGet', options, true);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHhometownDASHnewsInfiniteOptions = (options: Options<HometownNewsListUsingGetData>) => {
    return infiniteQueryOptions<HometownNewsListUsingGetResponse, DefaultError, InfiniteData<HometownNewsListUsingGetResponse>, QueryKey<Options<HometownNewsListUsingGetData>>, number | Pick<QueryKey<Options<HometownNewsListUsingGetData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<HometownNewsListUsingGetData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHhometownDASHnews({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHhometownDASHnewsInfiniteQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHhometownDASHnewsSLASHfeedbackSLASHLBRACEhometownUNDERSCOREnewsUNDERSCOREidRBRACEQueryKey = (options: Options<HometownNewsFeedbackUsingGetData>) => createQueryKey('hometownNewsFeedbackUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHhometownDASHnewsSLASHfeedbackSLASHLBRACEhometownUNDERSCOREnewsUNDERSCOREidRBRACEOptions = (options: Options<HometownNewsFeedbackUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHhometownDASHnewsSLASHfeedbackSLASHLBRACEhometownUNDERSCOREnewsUNDERSCOREidRBRACE({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHhometownDASHnewsSLASHfeedbackSLASHLBRACEhometownUNDERSCOREnewsUNDERSCOREidRBRACEQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHhometownDASHnewsSLASHpopularQueryKey = (options?: Options<GetPopularHometownNewsListUsingGetData>) => createQueryKey('getPopularHometownNewsListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHhometownDASHnewsSLASHpopularOptions = (options?: Options<GetPopularHometownNewsListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHhometownDASHnewsSLASHpopular({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHhometownDASHnewsSLASHpopularQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHhometownDASHnewsSLASHpopularSLASHcommunityQueryKey = (options?: Options<GetPopularHometownNewsListForCommunityUsingGetData>) => createQueryKey('getPopularHometownNewsListForCommunityUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHhometownDASHnewsSLASHpopularSLASHcommunityOptions = (options?: Options<GetPopularHometownNewsListForCommunityUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHhometownDASHnewsSLASHpopularSLASHcommunity({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHhometownDASHnewsSLASHpopularSLASHcommunityQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHhometownDASHnewsSLASHLBRACEhometownUNDERSCOREnewsUNDERSCOREidUNDERSCOREidxRBRACEQueryKey = (options: Options<HometownNewsUsingGetData>) => createQueryKey('hometownNewsUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHhometownDASHnewsSLASHLBRACEhometownUNDERSCOREnewsUNDERSCOREidUNDERSCOREidxRBRACEOptions = (options: Options<HometownNewsUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHhometownDASHnewsSLASHLBRACEhometownUNDERSCOREnewsUNDERSCOREidUNDERSCOREidxRBRACE({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHhometownDASHnewsSLASHLBRACEhometownUNDERSCOREnewsUNDERSCOREidUNDERSCOREidxRBRACEQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcsSLASHinquiryQueryKey = (options: Options<InquiryListUsingGetData>) => createQueryKey('inquiryListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcsSLASHinquiryOptions = (options: Options<InquiryListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHcsSLASHinquiry({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHcsSLASHinquiryQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcsSLASHinquiryInfiniteQueryKey = (options: Options<InquiryListUsingGetData>): QueryKey<Options<InquiryListUsingGetData>> => createQueryKey('inquiryListUsingGet', options, true);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcsSLASHinquiryInfiniteOptions = (options: Options<InquiryListUsingGetData>) => {
    return infiniteQueryOptions<InquiryListUsingGetResponse, DefaultError, InfiniteData<InquiryListUsingGetResponse>, QueryKey<Options<InquiryListUsingGetData>>, number | Pick<QueryKey<Options<InquiryListUsingGetData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<InquiryListUsingGetData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHcsSLASHinquiry({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHcsSLASHinquiryInfiniteQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHcsSLASHinquiryQueryKey = (options?: Options<SaveInquiryUsingPostData>) => createQueryKey('saveInquiryUsingPost', options);

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHcsSLASHinquiryOptions = (options?: Options<SaveInquiryUsingPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHcsSLASHinquiry({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postMETHODSLASHwelloSLASHv2SLASHauthSLASHcsSLASHinquiryQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHcsSLASHinquiryMutation = (options?: Partial<Options<SaveInquiryUsingPostData>>) => {
    const mutationOptions: UseMutationOptions<SaveInquiryUsingPostResponse, DefaultError, Options<SaveInquiryUsingPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHcsSLASHinquiry({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcsSLASHinquirySLASHLBRACEinquiryUNDERSCOREidRBRACEQueryKey = (options: Options<GetInquiryUsingGetData>) => createQueryKey('getInquiryUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcsSLASHinquirySLASHLBRACEinquiryUNDERSCOREidRBRACEOptions = (options: Options<GetInquiryUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHcsSLASHinquirySLASHLBRACEinquiryUNDERSCOREidRBRACE({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHcsSLASHinquirySLASHLBRACEinquiryUNDERSCOREidRBRACEQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHkbQueryKey = (options?: Options<SendPinkeyUsingPostData>) => createQueryKey('sendPinkeyUsingPost', options);

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHkbOptions = (options?: Options<SendPinkeyUsingPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHkb({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postMETHODSLASHwelloSLASHv2SLASHauthSLASHkbQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHkbMutation = (options?: Partial<Options<SendPinkeyUsingPostData>>) => {
    const mutationOptions: UseMutationOptions<SendPinkeyUsingPostResponse, DefaultError, Options<SendPinkeyUsingPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHkb({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHaccountQueryKey = (options?: Options<MemberAccountListUsingGetData>) => createQueryKey('memberAccountListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHaccountOptions = (options?: Options<MemberAccountListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHaccount({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHaccountQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHaccountQueryKey = (options: Options<SaveMemberAccountUsingPostData>) => createQueryKey('saveMemberAccountUsingPost', options);

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHaccountOptions = (options: Options<SaveMemberAccountUsingPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHaccount({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHaccountQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHaccountMutation = (options?: Partial<Options<SaveMemberAccountUsingPostData>>) => {
    const mutationOptions: UseMutationOptions<SaveMemberAccountUsingPostResponse, DefaultError, Options<SaveMemberAccountUsingPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHaccount({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHaccountSLASHavailableQueryKey = (options?: Options<GetMemberAccountUsingGetData>) => createQueryKey('getMemberAccountUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHaccountSLASHavailableOptions = (options?: Options<GetMemberAccountUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHaccountSLASHavailable({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHaccountSLASHavailableQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHcardQueryKey = (options?: Options<MemberCardListUsingGetData>) => createQueryKey('memberCardListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHcardOptions = (options?: Options<MemberCardListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHcard({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHcardQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHcardQueryKey = (options: Options<SaveMemberCardUsingPostData>) => createQueryKey('saveMemberCardUsingPost', options);

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHcardOptions = (options: Options<SaveMemberCardUsingPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHcard({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHcardQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHcardMutation = (options?: Partial<Options<SaveMemberCardUsingPostData>>) => {
    const mutationOptions: UseMutationOptions<SaveMemberCardUsingPostResponse, DefaultError, Options<SaveMemberCardUsingPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHcard({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const putMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHcardMutation = (options?: Partial<Options<UpdateIssueAtUsingPutData>>) => {
    const mutationOptions: UseMutationOptions<UpdateIssueAtUsingPutResponse, DefaultError, Options<UpdateIssueAtUsingPutData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await putMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHcard({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const putMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHcardSLASHcardDASHimageMutation = (options?: Partial<Options<UploadCardImageUsingPutData>>) => {
    const mutationOptions: UseMutationOptions<UploadCardImageUsingPutResponse, DefaultError, Options<UploadCardImageUsingPutData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await putMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHcardSLASHcardDASHimage({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHfilterSLASHfitQueryKey = (options?: Options<PutFitFilterUsingPostData>) => createQueryKey('putFitFilterUsingPost', options);

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHfilterSLASHfitOptions = (options?: Options<PutFitFilterUsingPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHfilterSLASHfit({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHfilterSLASHfitQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHfilterSLASHfitMutation = (options?: Partial<Options<PutFitFilterUsingPostData>>) => {
    const mutationOptions: UseMutationOptions<PutFitFilterUsingPostResponse, DefaultError, Options<PutFitFilterUsingPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHfilterSLASHfit({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHfilterSLASHfitDASHnewQueryKey = (options?: Options<SaveFitFilterUsingPostData>) => createQueryKey('saveFitFilterUsingPost', options);

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHfilterSLASHfitDASHnewOptions = (options?: Options<SaveFitFilterUsingPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHfilterSLASHfitDASHnew({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHfilterSLASHfitDASHnewQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHfilterSLASHfitDASHnewMutation = (options?: Partial<Options<SaveFitFilterUsingPostData>>) => {
    const mutationOptions: UseMutationOptions<SaveFitFilterUsingPostResponse, DefaultError, Options<SaveFitFilterUsingPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHfilterSLASHfitDASHnew({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHfilterSLASHinterestQueryKey = (options?: Options<InterestFilterUsingGetData>) => createQueryKey('interestFilterUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHfilterSLASHinterestOptions = (options?: Options<InterestFilterUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHfilterSLASHinterest({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHfilterSLASHinterestQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHfilterSLASHinterestQueryKey = (options?: Options<SaveInterestFilterUsingPostData>) => createQueryKey('saveInterestFilterUsingPost', options);

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHfilterSLASHinterestOptions = (options?: Options<SaveInterestFilterUsingPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHfilterSLASHinterest({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHfilterSLASHinterestQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHfilterSLASHinterestMutation = (options?: Partial<Options<SaveInterestFilterUsingPostData>>) => {
    const mutationOptions: UseMutationOptions<SaveInterestFilterUsingPostResponse, DefaultError, Options<SaveInterestFilterUsingPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHfilterSLASHinterest({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHfilterSLASHkbQueryKey = (options?: Options<SaveKbFilterUsingPostData>) => createQueryKey('saveKbFilterUsingPost', options);

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHfilterSLASHkbOptions = (options?: Options<SaveKbFilterUsingPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHfilterSLASHkb({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHfilterSLASHkbQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHfilterSLASHkbMutation = (options?: Partial<Options<SaveKbFilterUsingPostData>>) => {
    const mutationOptions: UseMutationOptions<SaveKbFilterUsingPostResponse, DefaultError, Options<SaveKbFilterUsingPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHfilterSLASHkb({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHfilterSLASHregionQueryKey = (options?: Options<NoticeListUsingPostData>) => createQueryKey('noticeListUsingPost', options);

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHfilterSLASHregionOptions = (options?: Options<NoticeListUsingPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHfilterSLASHregion({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHfilterSLASHregionQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHfilterSLASHregionMutation = (options?: Partial<Options<NoticeListUsingPostData>>) => {
    const mutationOptions: UseMutationOptions<NoticeListUsingPostResponse, DefaultError, Options<NoticeListUsingPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHfilterSLASHregion({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHfilterSLASHrequiredQueryKey = (options?: Options<RequiredFilterUsingGetData>) => createQueryKey('requiredFilterUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHfilterSLASHrequiredOptions = (options?: Options<RequiredFilterUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHfilterSLASHrequired({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHfilterSLASHrequiredQueryKey(options)
    });
};

export const deleteMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberMutation = (options?: Partial<Options<ResignMemberUsingDeleteData>>) => {
    const mutationOptions: UseMutationOptions<ResignMemberUsingDeleteResponse, DefaultError, Options<ResignMemberUsingDeleteData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await deleteMETHODSLASHwelloSLASHv2SLASHauthSLASHmember({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberQueryKey = (options?: Options<FileUploadUsingPostData>) => createQueryKey('fileUploadUsingPost', options);

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberOptions = (options?: Options<FileUploadUsingPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHmember({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberMutation = (options?: Partial<Options<FileUploadUsingPostData>>) => {
    const mutationOptions: UseMutationOptions<FileUploadUsingPostResponse, DefaultError, Options<FileUploadUsingPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHmember({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHactionDASHcountQueryKey = (options?: Options<GetActionCountUsingGetData>) => createQueryKey('getActionCountUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHactionDASHcountOptions = (options?: Options<GetActionCountUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHactionDASHcount({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHactionDASHcountQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHcontentDASHcountQueryKey = (options?: Options<MemberContentCountUsingGetData>) => createQueryKey('memberContentCountUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHcontentDASHcountOptions = (options?: Options<MemberContentCountUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHcontentDASHcount({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHcontentDASHcountQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHinterestSLASHpolicyQueryKey = (options?: Options<MemberInterestPolicyListUsingGetData>) => createQueryKey('memberInterestPolicyListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHinterestSLASHpolicyOptions = (options?: Options<MemberInterestPolicyListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHinterestSLASHpolicy({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHinterestSLASHpolicyQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHinvitedDASHmemberDASHcountQueryKey = (options?: Options<GetInvitedMemberCountUsingGetData>) => createQueryKey('getInvitedMemberCountUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHinvitedDASHmemberDASHcountOptions = (options?: Options<GetInvitedMemberCountUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHinvitedDASHmemberDASHcount({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHinvitedDASHmemberDASHcountQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHkbDASHmemberDASHcheckQueryKey = (options?: Options<KbMemberCheckUsingPostData>) => createQueryKey('kbMemberCheckUsingPost', options);

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHkbDASHmemberDASHcheckOptions = (options?: Options<KbMemberCheckUsingPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHkbDASHmemberDASHcheck({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHkbDASHmemberDASHcheckQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHkbDASHmemberDASHcheckMutation = (options?: Partial<Options<KbMemberCheckUsingPostData>>) => {
    const mutationOptions: UseMutationOptions<KbMemberCheckUsingPostResponse, DefaultError, Options<KbMemberCheckUsingPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHkbDASHmemberDASHcheck({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const putMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHmessageDASHreceiveMutation = (options?: Partial<Options<MessageReceiveUsingPutData>>) => {
    const mutationOptions: UseMutationOptions<MessageReceiveUsingPutResponse, DefaultError, Options<MessageReceiveUsingPutData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await putMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHmessageDASHreceive({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHneighborSLASHpolicyQueryKey = (options?: Options<MemberNeighborPolicyListUsingGetData>) => createQueryKey('memberNeighborPolicyListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHneighborSLASHpolicyOptions = (options?: Options<MemberNeighborPolicyListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHneighborSLASHpolicy({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHneighborSLASHpolicyQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHpeerDASHgroupSLASHpolicyQueryKey = (options?: Options<MemberPeerGroupPolicyListUsingGetData>) => createQueryKey('memberPeerGroupPolicyListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHpeerDASHgroupSLASHpolicyOptions = (options?: Options<MemberPeerGroupPolicyListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHpeerDASHgroupSLASHpolicy({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHpeerDASHgroupSLASHpolicyQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHpolicySLASHprovisionDASHtypeDASHcountQueryKey = (options?: Options<MemberPolicyListUsingGetData>) => createQueryKey('memberPolicyListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHpolicySLASHprovisionDASHtypeDASHcountOptions = (options?: Options<MemberPolicyListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHpolicySLASHprovisionDASHtypeDASHcount({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHpolicySLASHprovisionDASHtypeDASHcountQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHprofileQueryKey = (options?: Options<MemberUsingGetData>) => createQueryKey('memberUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHprofileOptions = (options?: Options<MemberUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHprofile({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHprofileQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHprofileQueryKey = (options?: Options<SaveMemberNickNameUsingPostData>) => createQueryKey('saveMemberNickNameUsingPost', options);

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHprofileOptions = (options?: Options<SaveMemberNickNameUsingPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHprofile({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHprofileQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHprofileMutation = (options?: Partial<Options<SaveMemberNickNameUsingPostData>>) => {
    const mutationOptions: UseMutationOptions<SaveMemberNickNameUsingPostResponse, DefaultError, Options<SaveMemberNickNameUsingPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHprofile({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const putMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHprofileMutation = (options?: Partial<Options<UpdateMemberNickNameUsingPutData>>) => {
    const mutationOptions: UseMutationOptions<UpdateMemberNickNameUsingPutResponse, DefaultError, Options<UpdateMemberNickNameUsingPutData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await putMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHprofile({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHrecentSLASHpolicyQueryKey = (options?: Options<MemberRecentPolicyListUsingGetData>) => createQueryKey('memberRecentPolicyListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHrecentSLASHpolicyOptions = (options?: Options<MemberRecentPolicyListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHrecentSLASHpolicy({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHrecentSLASHpolicyQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHrecentSLASHrecommendSLASHpolicyQueryKey = (options?: Options<MemberRecommendPolicyByRecentListUsingGetData>) => createQueryKey('memberRecommendPolicyByRecentListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHrecentSLASHrecommendSLASHpolicyOptions = (options?: Options<MemberRecommendPolicyByRecentListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHrecentSLASHrecommendSLASHpolicy({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHrecentSLASHrecommendSLASHpolicyQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHrecommendSLASHpolicyQueryKey = (options: Options<MemberNewPolicyListUsingGetData>) => createQueryKey('memberNewPolicyListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHrecommendSLASHpolicyOptions = (options: Options<MemberNewPolicyListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHrecommendSLASHpolicy({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHrecommendSLASHpolicyQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHrecommendSLASHpolicyInfiniteQueryKey = (options: Options<MemberNewPolicyListUsingGetData>): QueryKey<Options<MemberNewPolicyListUsingGetData>> => createQueryKey('memberNewPolicyListUsingGet', options, true);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHrecommendSLASHpolicyInfiniteOptions = (options: Options<MemberNewPolicyListUsingGetData>) => {
    return infiniteQueryOptions<MemberNewPolicyListUsingGetResponse, DefaultError, InfiniteData<MemberNewPolicyListUsingGetResponse>, QueryKey<Options<MemberNewPolicyListUsingGetData>>, number | Pick<QueryKey<Options<MemberNewPolicyListUsingGetData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<MemberNewPolicyListUsingGetData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHrecommendSLASHpolicy({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHrecommendSLASHpolicyInfiniteQueryKey(options)
    });
};

export const deleteMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHsocialDASHaccountsMutation = (options?: Partial<Options<DeleteMemberSocialAccountsUsingDeleteData>>) => {
    const mutationOptions: UseMutationOptions<DeleteMemberSocialAccountsUsingDeleteResponse, DefaultError, Options<DeleteMemberSocialAccountsUsingDeleteData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await deleteMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHsocialDASHaccounts({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHsocialDASHaccountsQueryKey = (options?: Options<MemberSocialAccountsUsingGetData>) => createQueryKey('memberSocialAccountsUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHsocialDASHaccountsOptions = (options?: Options<MemberSocialAccountsUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHsocialDASHaccounts({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHsocialDASHaccountsQueryKey(options)
    });
};

export const putMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHverificationMutation = (options?: Partial<Options<UpdateMemberVerificationUsingPutData>>) => {
    const mutationOptions: UseMutationOptions<UpdateMemberVerificationUsingPutResponse, DefaultError, Options<UpdateMemberVerificationUsingPutData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await putMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHverification({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHtermDASHagreementQueryKey = (options: Options<GetMemberTermAgreementByAgreementTypeUsingGetData>) => createQueryKey('getMemberTermAgreementByAgreementTypeUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHtermDASHagreementOptions = (options: Options<GetMemberTermAgreementByAgreementTypeUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHtermDASHagreement({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHtermDASHagreementQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHtermDASHagreementQueryKey = (options?: Options<SaveOrUpdateMemberTermAgreementUsingPostData>) => createQueryKey('saveOrUpdateMemberTermAgreementUsingPost', options);

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHtermDASHagreementOptions = (options?: Options<SaveOrUpdateMemberTermAgreementUsingPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHtermDASHagreement({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHtermDASHagreementQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHtermDASHagreementMutation = (options?: Partial<Options<SaveOrUpdateMemberTermAgreementUsingPostData>>) => {
    const mutationOptions: UseMutationOptions<SaveOrUpdateMemberTermAgreementUsingPostResponse, DefaultError, Options<SaveOrUpdateMemberTermAgreementUsingPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHtermDASHagreement({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHverificationQueryKey = (options?: Options<GetLatestCompletedCiUsingPostData>) => createQueryKey('getLatestCompletedCiUsingPost', options);

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHverificationOptions = (options?: Options<GetLatestCompletedCiUsingPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHverification({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHverificationQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHverificationMutation = (options?: Partial<Options<GetLatestCompletedCiUsingPostData>>) => {
    const mutationOptions: UseMutationOptions<GetLatestCompletedCiUsingPostResponse, DefaultError, Options<GetLatestCompletedCiUsingPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHverification({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHverificationSLASHcheckQueryKey = (options?: Options<GetMemberVerificationIdUsingGetData>) => createQueryKey('getMemberVerificationIdUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHverificationSLASHcheckOptions = (options?: Options<GetMemberVerificationIdUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHverificationSLASHcheck({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHverificationSLASHcheckQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHverificationSLASHdecryptQueryKey = (options?: Options<DecryptMemberVerificationUsingPostData>) => createQueryKey('decryptMemberVerificationUsingPost', options);

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHverificationSLASHdecryptOptions = (options?: Options<DecryptMemberVerificationUsingPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHverificationSLASHdecrypt({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHverificationSLASHdecryptQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHverificationSLASHdecryptMutation = (options?: Partial<Options<DecryptMemberVerificationUsingPostData>>) => {
    const mutationOptions: UseMutationOptions<DecryptMemberVerificationUsingPostResponse, DefaultError, Options<DecryptMemberVerificationUsingPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHverificationSLASHdecrypt({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHverificationSLASHinfoQueryKey = (options?: Options<GetLatestCompletedUsingPostData>) => createQueryKey('getLatestCompletedUsingPost', options);

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHverificationSLASHinfoOptions = (options?: Options<GetLatestCompletedUsingPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHverificationSLASHinfo({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHverificationSLASHinfoQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHverificationSLASHinfoMutation = (options?: Partial<Options<GetLatestCompletedUsingPostData>>) => {
    const mutationOptions: UseMutationOptions<GetLatestCompletedUsingPostResponse, DefaultError, Options<GetLatestCompletedUsingPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHverificationSLASHinfo({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHniceDASHsafeDASHkeyQueryKey = (options?: Options<SendNiceSafeKeyUsingPostData>) => createQueryKey('sendNiceSafeKeyUsingPost', options);

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHniceDASHsafeDASHkeyOptions = (options?: Options<SendNiceSafeKeyUsingPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHniceDASHsafeDASHkey({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postMETHODSLASHwelloSLASHv2SLASHauthSLASHniceDASHsafeDASHkeyQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHniceDASHsafeDASHkeyMutation = (options?: Partial<Options<SendNiceSafeKeyUsingPostData>>) => {
    const mutationOptions: UseMutationOptions<SendNiceSafeKeyUsingPostResponse, DefaultError, Options<SendNiceSafeKeyUsingPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHniceDASHsafeDASHkey({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHniceDASHsafeDASHkeySLASHcheckDASHplusDASHsendDASHresultQueryKey = (options?: Options<CheckPlusSendResultUsingGetData>) => createQueryKey('checkPlusSendResultUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHniceDASHsafeDASHkeySLASHcheckDASHplusDASHsendDASHresultOptions = (options?: Options<CheckPlusSendResultUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHniceDASHsafeDASHkeySLASHcheckDASHplusDASHsendDASHresult({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHniceDASHsafeDASHkeySLASHcheckDASHplusDASHsendDASHresultQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHniceDASHsafeDASHkeySLASHcheckDASHplusUNDERSCOREfailQueryKey = (options?: Options<CheckPlusFailUsingGetData>) => createQueryKey('checkPlusFailUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHniceDASHsafeDASHkeySLASHcheckDASHplusUNDERSCOREfailOptions = (options?: Options<CheckPlusFailUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHniceDASHsafeDASHkeySLASHcheckDASHplusUNDERSCOREfail({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHniceDASHsafeDASHkeySLASHcheckDASHplusUNDERSCOREfailQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHwelloSLASHblockQueryKey = (options: Options<GetWelloMemberBlockListUsingGetData>) => createQueryKey('getWelloMemberBlockListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHwelloSLASHblockOptions = (options: Options<GetWelloMemberBlockListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHwelloSLASHblock({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHwelloSLASHblockQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHwelloSLASHblockInfiniteQueryKey = (options: Options<GetWelloMemberBlockListUsingGetData>): QueryKey<Options<GetWelloMemberBlockListUsingGetData>> => createQueryKey('getWelloMemberBlockListUsingGet', options, true);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHwelloSLASHblockInfiniteOptions = (options: Options<GetWelloMemberBlockListUsingGetData>) => {
    return infiniteQueryOptions<GetWelloMemberBlockListUsingGetResponse, DefaultError, InfiniteData<GetWelloMemberBlockListUsingGetResponse>, QueryKey<Options<GetWelloMemberBlockListUsingGetData>>, number | Pick<QueryKey<Options<GetWelloMemberBlockListUsingGetData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetWelloMemberBlockListUsingGetData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHwelloSLASHblock({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHwelloSLASHblockInfiniteQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHwelloSLASHblockSLASHbyDASHcommunitySLASHLBRACEcommunityUNDERSCOREidRBRACEQueryKey = (options: Options<BlockWelloMemberByCommunityUsingPostData>) => createQueryKey('blockWelloMemberByCommunityUsingPost', options);

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHwelloSLASHblockSLASHbyDASHcommunitySLASHLBRACEcommunityUNDERSCOREidRBRACEOptions = (options: Options<BlockWelloMemberByCommunityUsingPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHwelloSLASHblockSLASHbyDASHcommunitySLASHLBRACEcommunityUNDERSCOREidRBRACE({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHwelloSLASHblockSLASHbyDASHcommunitySLASHLBRACEcommunityUNDERSCOREidRBRACEQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHwelloSLASHblockSLASHbyDASHcommunitySLASHLBRACEcommunityUNDERSCOREidRBRACEMutation = (options?: Partial<Options<BlockWelloMemberByCommunityUsingPostData>>) => {
    const mutationOptions: UseMutationOptions<BlockWelloMemberByCommunityUsingPostResponse, DefaultError, Options<BlockWelloMemberByCommunityUsingPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHwelloSLASHblockSLASHbyDASHcommunitySLASHLBRACEcommunityUNDERSCOREidRBRACE({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const deleteMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHwelloSLASHblockSLASHLBRACEblockedUNDERSCOREmemberUNDERSCOREidRBRACEMutation = (options?: Partial<Options<DeleteMemberWelloBlockUsingDeleteData>>) => {
    const mutationOptions: UseMutationOptions<DeleteMemberWelloBlockUsingDeleteResponse, DefaultError, Options<DeleteMemberWelloBlockUsingDeleteData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await deleteMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHwelloSLASHblockSLASHLBRACEblockedUNDERSCOREmemberUNDERSCOREidRBRACE({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHcertificationSLASHcellphoneQueryKey = (options?: Options<SendCertificationCellphoneUsingPostData>) => createQueryKey('sendCertificationCellphoneUsingPost', options);

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHcertificationSLASHcellphoneOptions = (options?: Options<SendCertificationCellphoneUsingPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHcertificationSLASHcellphone({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postMETHODSLASHwelloSLASHv2SLASHauthSLASHcertificationSLASHcellphoneQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHcertificationSLASHcellphoneMutation = (options?: Partial<Options<SendCertificationCellphoneUsingPostData>>) => {
    const mutationOptions: UseMutationOptions<SendCertificationCellphoneUsingPostResponse, DefaultError, Options<SendCertificationCellphoneUsingPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHcertificationSLASHcellphone({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHcertificationSLASHcheckQueryKey = (options?: Options<CertificationCheckUsingPostData>) => createQueryKey('certificationCheckUsingPost', options);

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHcertificationSLASHcheckOptions = (options?: Options<CertificationCheckUsingPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHcertificationSLASHcheck({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postMETHODSLASHwelloSLASHv2SLASHauthSLASHcertificationSLASHcheckQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHcertificationSLASHcheckMutation = (options?: Partial<Options<CertificationCheckUsingPostData>>) => {
    const mutationOptions: UseMutationOptions<CertificationCheckUsingPostResponse, DefaultError, Options<CertificationCheckUsingPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHcertificationSLASHcheck({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHwelloSLASHlocationDASHserviceDASHconsentQueryKey = (options?: Options<GetLocationServiceConsentUsingGetData>) => createQueryKey('getLocationServiceConsentUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHwelloSLASHlocationDASHserviceDASHconsentOptions = (options?: Options<GetLocationServiceConsentUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHwelloSLASHlocationDASHserviceDASHconsent({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHwelloSLASHlocationDASHserviceDASHconsentQueryKey(options)
    });
};

export const putMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHwelloSLASHlocationDASHserviceDASHconsentMutation = (options?: Partial<Options<UpdateLocationServiceConsentUsingPutData>>) => {
    const mutationOptions: UseMutationOptions<UpdateLocationServiceConsentUsingPutResponse, DefaultError, Options<UpdateLocationServiceConsentUsingPutData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await putMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHwelloSLASHlocationDASHserviceDASHconsent({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHwelloSLASHprivateUNDERSCOREdataUNDERSCOREconsentQueryKey = (options?: Options<GetPrivateDataConsentUsingGetData>) => createQueryKey('getPrivateDataConsentUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHwelloSLASHprivateUNDERSCOREdataUNDERSCOREconsentOptions = (options?: Options<GetPrivateDataConsentUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHwelloSLASHprivateUNDERSCOREdataUNDERSCOREconsent({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHwelloSLASHprivateUNDERSCOREdataUNDERSCOREconsentQueryKey(options)
    });
};

export const putMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHwelloSLASHprivateUNDERSCOREdataUNDERSCOREconsentMutation = (options?: Partial<Options<UpdatePrivateDataConsentUsingPutData>>) => {
    const mutationOptions: UseMutationOptions<UpdatePrivateDataConsentUsingPutResponse, DefaultError, Options<UpdatePrivateDataConsentUsingPutData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await putMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberDASHwelloSLASHprivateUNDERSCOREdataUNDERSCOREconsent({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const putMETHODSLASHwelloSLASHv2SLASHauthSLASHmessageDASHrejectSLASHmemberDASHwelloMutation = (options?: Partial<Options<RejectMessageUsingPutData>>) => {
    const mutationOptions: UseMutationOptions<RejectMessageUsingPutResponse, DefaultError, Options<RejectMessageUsingPutData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await putMETHODSLASHwelloSLASHv2SLASHauthSLASHmessageDASHrejectSLASHmemberDASHwello({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicyQueryKey = (options: Options<MetaPolicyListUsingGetData>) => createQueryKey('metaPolicyListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicyOptions = (options: Options<MetaPolicyListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicy({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicyQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicyInfiniteQueryKey = (options: Options<MetaPolicyListUsingGetData>): QueryKey<Options<MetaPolicyListUsingGetData>> => createQueryKey('metaPolicyListUsingGet', options, true);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicyInfiniteOptions = (options: Options<MetaPolicyListUsingGetData>) => {
    return infiniteQueryOptions<MetaPolicyListUsingGetResponse, DefaultError, InfiniteData<MetaPolicyListUsingGetResponse>, QueryKey<Options<MetaPolicyListUsingGetData>>, number | Pick<QueryKey<Options<MetaPolicyListUsingGetData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<MetaPolicyListUsingGetData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicy({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicyInfiniteQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHfeedbackSLASHLBRACEpolicyUNDERSCOREidRBRACEQueryKey = (options: Options<MetaPolicyFeedbackUsingGetData>) => createQueryKey('metaPolicyFeedbackUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHfeedbackSLASHLBRACEpolicyUNDERSCOREidRBRACEOptions = (options: Options<MetaPolicyFeedbackUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHfeedbackSLASHLBRACEpolicyUNDERSCOREidRBRACE({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHfeedbackSLASHLBRACEpolicyUNDERSCOREidRBRACEQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHinterestDASHpolicyQueryKey = (options: Options<GetInterestPolicyListUsingGetData>) => createQueryKey('getInterestPolicyListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHinterestDASHpolicyOptions = (options: Options<GetInterestPolicyListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHinterestDASHpolicy({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHinterestDASHpolicyQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHinterestDASHpolicyInfiniteQueryKey = (options: Options<GetInterestPolicyListUsingGetData>): QueryKey<Options<GetInterestPolicyListUsingGetData>> => createQueryKey('getInterestPolicyListUsingGet', options, true);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHinterestDASHpolicyInfiniteOptions = (options: Options<GetInterestPolicyListUsingGetData>) => {
    return infiniteQueryOptions<GetInterestPolicyListUsingGetResponse, DefaultError, InfiniteData<GetInterestPolicyListUsingGetResponse>, QueryKey<Options<GetInterestPolicyListUsingGetData>>, number | Pick<QueryKey<Options<GetInterestPolicyListUsingGetData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetInterestPolicyListUsingGetData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHinterestDASHpolicy({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHinterestDASHpolicyInfiniteQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHpolicySLASHLBRACEmetaUNDERSCOREpolicyUNDERSCOREidUNDERSCOREidxRBRACESLASHrelatedQueryKey = (options: Options<GetRelatedMetaPolicyListUsingGetData>) => createQueryKey('getRelatedMetaPolicyListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHpolicySLASHLBRACEmetaUNDERSCOREpolicyUNDERSCOREidUNDERSCOREidxRBRACESLASHrelatedOptions = (options: Options<GetRelatedMetaPolicyListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHpolicySLASHLBRACEmetaUNDERSCOREpolicyUNDERSCOREidUNDERSCOREidxRBRACESLASHrelated({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHpolicySLASHLBRACEmetaUNDERSCOREpolicyUNDERSCOREidUNDERSCOREidxRBRACESLASHrelatedQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHLBRACEmetaUNDERSCOREpolicyUNDERSCOREidUNDERSCOREidxRBRACEQueryKey = (options: Options<MetaPolicyUsingGetData>) => createQueryKey('metaPolicyUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHLBRACEmetaUNDERSCOREpolicyUNDERSCOREidUNDERSCOREidxRBRACEOptions = (options: Options<MetaPolicyUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHLBRACEmetaUNDERSCOREpolicyUNDERSCOREidUNDERSCOREidxRBRACE({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHLBRACEmetaUNDERSCOREpolicyUNDERSCOREidUNDERSCOREidxRBRACEQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHrecommendSLASHnearDASHexpiryQueryKey = (options: Options<GetRecommendNearExpiryPolicyListUsingGetData>) => createQueryKey('getRecommendNearExpiryPolicyListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHrecommendSLASHnearDASHexpiryOptions = (options: Options<GetRecommendNearExpiryPolicyListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHrecommendSLASHnearDASHexpiry({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHrecommendSLASHnearDASHexpiryQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHrecommendSLASHnearDASHexpiryInfiniteQueryKey = (options: Options<GetRecommendNearExpiryPolicyListUsingGetData>): QueryKey<Options<GetRecommendNearExpiryPolicyListUsingGetData>> => createQueryKey('getRecommendNearExpiryPolicyListUsingGet', options, true);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHrecommendSLASHnearDASHexpiryInfiniteOptions = (options: Options<GetRecommendNearExpiryPolicyListUsingGetData>) => {
    return infiniteQueryOptions<GetRecommendNearExpiryPolicyListUsingGetResponse, DefaultError, InfiniteData<GetRecommendNearExpiryPolicyListUsingGetResponse>, QueryKey<Options<GetRecommendNearExpiryPolicyListUsingGetData>>, number | Pick<QueryKey<Options<GetRecommendNearExpiryPolicyListUsingGetData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetRecommendNearExpiryPolicyListUsingGetData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHrecommendSLASHnearDASHexpiry({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHrecommendSLASHnearDASHexpiryInfiniteQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHrecommendSLASHnearDASHexpirySLASHprovisionDASHtypesQueryKey = (options?: Options<GetRecommendNearExpiryPolicyProvisionTypeAllListUsingGetData>) => createQueryKey('getRecommendNearExpiryPolicyProvisionTypeAllListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHrecommendSLASHnearDASHexpirySLASHprovisionDASHtypesOptions = (options?: Options<GetRecommendNearExpiryPolicyProvisionTypeAllListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHrecommendSLASHnearDASHexpirySLASHprovisionDASHtypes({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHrecommendSLASHnearDASHexpirySLASHprovisionDASHtypesQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHrecommendSLASHnewQueryKey = (options: Options<GetRecommendNewPolicyListUsingGetData>) => createQueryKey('getRecommendNewPolicyListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHrecommendSLASHnewOptions = (options: Options<GetRecommendNewPolicyListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHrecommendSLASHnew({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHrecommendSLASHnewQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHrecommendSLASHnewInfiniteQueryKey = (options: Options<GetRecommendNewPolicyListUsingGetData>): QueryKey<Options<GetRecommendNewPolicyListUsingGetData>> => createQueryKey('getRecommendNewPolicyListUsingGet', options, true);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHrecommendSLASHnewInfiniteOptions = (options: Options<GetRecommendNewPolicyListUsingGetData>) => {
    return infiniteQueryOptions<GetRecommendNewPolicyListUsingGetResponse, DefaultError, InfiniteData<GetRecommendNewPolicyListUsingGetResponse>, QueryKey<Options<GetRecommendNewPolicyListUsingGetData>>, number | Pick<QueryKey<Options<GetRecommendNewPolicyListUsingGetData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetRecommendNewPolicyListUsingGetData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHrecommendSLASHnew({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHrecommendSLASHnewInfiniteQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHrecommendSLASHnewSLASHprovisionDASHtypesQueryKey = (options?: Options<GetRecommendNewPolicyProvisionTypeAllListUsingGetData>) => createQueryKey('getRecommendNewPolicyProvisionTypeAllListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHrecommendSLASHnewSLASHprovisionDASHtypesOptions = (options?: Options<GetRecommendNewPolicyProvisionTypeAllListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHrecommendSLASHnewSLASHprovisionDASHtypes({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHrecommendSLASHnewSLASHprovisionDASHtypesQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHrecommendSLASHtrendingQueryKey = (options: Options<GetRecommendTrendingPolicyListUsingGetData>) => createQueryKey('getRecommendTrendingPolicyListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHrecommendSLASHtrendingOptions = (options: Options<GetRecommendTrendingPolicyListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHrecommendSLASHtrending({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHrecommendSLASHtrendingQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHrecommendSLASHtrendingInfiniteQueryKey = (options: Options<GetRecommendTrendingPolicyListUsingGetData>): QueryKey<Options<GetRecommendTrendingPolicyListUsingGetData>> => createQueryKey('getRecommendTrendingPolicyListUsingGet', options, true);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHrecommendSLASHtrendingInfiniteOptions = (options: Options<GetRecommendTrendingPolicyListUsingGetData>) => {
    return infiniteQueryOptions<GetRecommendTrendingPolicyListUsingGetResponse, DefaultError, InfiniteData<GetRecommendTrendingPolicyListUsingGetResponse>, QueryKey<Options<GetRecommendTrendingPolicyListUsingGetData>>, number | Pick<QueryKey<Options<GetRecommendTrendingPolicyListUsingGetData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetRecommendTrendingPolicyListUsingGetData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHrecommendSLASHtrending({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHrecommendSLASHtrendingInfiniteQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHrecommendSLASHtrendingSLASHprovisionDASHtypesQueryKey = (options?: Options<GetRecommendTrendingPolicyProvisionTypeAllListUsingGetData>) => createQueryKey('getRecommendTrendingPolicyProvisionTypeAllListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHrecommendSLASHtrendingSLASHprovisionDASHtypesOptions = (options?: Options<GetRecommendTrendingPolicyProvisionTypeAllListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHrecommendSLASHtrendingSLASHprovisionDASHtypes({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHrecommendSLASHtrendingSLASHprovisionDASHtypesQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHrecommendSLASHunreadQueryKey = (options: Options<GetRecommendUnreadPolicyListUsingGetData>) => createQueryKey('getRecommendUnreadPolicyListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHrecommendSLASHunreadOptions = (options: Options<GetRecommendUnreadPolicyListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHrecommendSLASHunread({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHrecommendSLASHunreadQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHrecommendSLASHunreadInfiniteQueryKey = (options: Options<GetRecommendUnreadPolicyListUsingGetData>): QueryKey<Options<GetRecommendUnreadPolicyListUsingGetData>> => createQueryKey('getRecommendUnreadPolicyListUsingGet', options, true);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHrecommendSLASHunreadInfiniteOptions = (options: Options<GetRecommendUnreadPolicyListUsingGetData>) => {
    return infiniteQueryOptions<GetRecommendUnreadPolicyListUsingGetResponse, DefaultError, InfiniteData<GetRecommendUnreadPolicyListUsingGetResponse>, QueryKey<Options<GetRecommendUnreadPolicyListUsingGetData>>, number | Pick<QueryKey<Options<GetRecommendUnreadPolicyListUsingGetData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetRecommendUnreadPolicyListUsingGetData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHrecommendSLASHunread({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHrecommendSLASHunreadInfiniteQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHrecommendSLASHunreadSLASHprovisionDASHtypesQueryKey = (options?: Options<GetRecommendUnreadPolicyProvisionTypeAllListUsingGetData>) => createQueryKey('getRecommendUnreadPolicyProvisionTypeAllListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHrecommendSLASHunreadSLASHprovisionDASHtypesOptions = (options?: Options<GetRecommendUnreadPolicyProvisionTypeAllListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHrecommendSLASHunreadSLASHprovisionDASHtypes({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicySLASHrecommendSLASHunreadSLASHprovisionDASHtypesQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHpaymentDASHhisQueryKey = (options?: Options<PaymentHisListUsingGetData>) => createQueryKey('paymentHisListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHpaymentDASHhisOptions = (options?: Options<PaymentHisListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHpaymentDASHhis({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHpaymentDASHhisQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHpaymentDASHhisSLASHtotalDASHcountQueryKey = (options?: Options<TotalPaymentHisListUsingGetData>) => createQueryKey('totalPaymentHisListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHpaymentDASHhisSLASHtotalDASHcountOptions = (options?: Options<TotalPaymentHisListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHpaymentDASHhisSLASHtotalDASHcount({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHpaymentDASHhisSLASHtotalDASHcountQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHpointQueryKey = (options?: Options<GetDetailPointBalanceUsingGetData>) => createQueryKey('getDetailPointBalanceUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHpointOptions = (options?: Options<GetDetailPointBalanceUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHpoint({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHpointQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHpointSLASHattendanceQueryKey = (options?: Options<GetListPointAttendanceUsingGetData>) => createQueryKey('getListPointAttendanceUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHpointSLASHattendanceOptions = (options?: Options<GetListPointAttendanceUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHpointSLASHattendance({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHpointSLASHattendanceQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHpointSLASHattendanceQueryKey = (options?: Options<SaveTodayAttendanceUsingPostData>) => createQueryKey('saveTodayAttendanceUsingPost', options);

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHpointSLASHattendanceOptions = (options?: Options<SaveTodayAttendanceUsingPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHpointSLASHattendance({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postMETHODSLASHwelloSLASHv2SLASHauthSLASHpointSLASHattendanceQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHpointSLASHattendanceMutation = (options?: Partial<Options<SaveTodayAttendanceUsingPostData>>) => {
    const mutationOptions: UseMutationOptions<SaveTodayAttendanceUsingPostResponse, DefaultError, Options<SaveTodayAttendanceUsingPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHpointSLASHattendance({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHpointSLASHeventQueryKey = (options?: Options<GetPointBudgetUsingGetData>) => createQueryKey('getPointBudgetUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHpointSLASHeventOptions = (options?: Options<GetPointBudgetUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHpointSLASHevent({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHpointSLASHeventQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHpointSLASHhistoryQueryKey = (options: Options<GetListPointHistoryUsingGetData>) => createQueryKey('getListPointHistoryUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHpointSLASHhistoryOptions = (options: Options<GetListPointHistoryUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHpointSLASHhistory({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHpointSLASHhistoryQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHpointSLASHhistoryInfiniteQueryKey = (options: Options<GetListPointHistoryUsingGetData>): QueryKey<Options<GetListPointHistoryUsingGetData>> => createQueryKey('getListPointHistoryUsingGet', options, true);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHpointSLASHhistoryInfiniteOptions = (options: Options<GetListPointHistoryUsingGetData>) => {
    return infiniteQueryOptions<GetListPointHistoryUsingGetResponse, DefaultError, InfiniteData<GetListPointHistoryUsingGetResponse>, QueryKey<Options<GetListPointHistoryUsingGetData>>, number | Pick<QueryKey<Options<GetListPointHistoryUsingGetData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetListPointHistoryUsingGetData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHpointSLASHhistory({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHpointSLASHhistoryInfiniteQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHpointSLASHwithdrawalQueryKey = (options: Options<SavePointWithdrawalUsingPostData>) => createQueryKey('savePointWithdrawalUsingPost', options);

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHpointSLASHwithdrawalOptions = (options: Options<SavePointWithdrawalUsingPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHpointSLASHwithdrawal({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postMETHODSLASHwelloSLASHv2SLASHauthSLASHpointSLASHwithdrawalQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHpointSLASHwithdrawalMutation = (options?: Partial<Options<SavePointWithdrawalUsingPostData>>) => {
    const mutationOptions: UseMutationOptions<SavePointWithdrawalUsingPostResponse, DefaultError, Options<SavePointWithdrawalUsingPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHpointSLASHwithdrawal({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHpointDASHmarketSLASHorderQueryKey = (options?: Options<GetPointMarketOrderListUsingGetData>) => createQueryKey('getPointMarketOrderListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHpointDASHmarketSLASHorderOptions = (options?: Options<GetPointMarketOrderListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHpointDASHmarketSLASHorder({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHpointDASHmarketSLASHorderQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHpointDASHmarketSLASHorderInfiniteQueryKey = (options?: Options<GetPointMarketOrderListUsingGetData>): QueryKey<Options<GetPointMarketOrderListUsingGetData>> => createQueryKey('getPointMarketOrderListUsingGet', options, true);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHpointDASHmarketSLASHorderInfiniteOptions = (options?: Options<GetPointMarketOrderListUsingGetData>) => {
    return infiniteQueryOptions<GetPointMarketOrderListUsingGetResponse, DefaultError, InfiniteData<GetPointMarketOrderListUsingGetResponse>, QueryKey<Options<GetPointMarketOrderListUsingGetData>>, number | Pick<QueryKey<Options<GetPointMarketOrderListUsingGetData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetPointMarketOrderListUsingGetData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHpointDASHmarketSLASHorder({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHpointDASHmarketSLASHorderInfiniteQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHpointDASHmarketSLASHorderSLASHpaymentsQueryKey = (options?: Options<PayPointMarketOrderUsingPostData>) => createQueryKey('payPointMarketOrderUsingPost', options);

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHpointDASHmarketSLASHorderSLASHpaymentsOptions = (options?: Options<PayPointMarketOrderUsingPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHpointDASHmarketSLASHorderSLASHpayments({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postMETHODSLASHwelloSLASHv2SLASHauthSLASHpointDASHmarketSLASHorderSLASHpaymentsQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHpointDASHmarketSLASHorderSLASHpaymentsMutation = (options?: Partial<Options<PayPointMarketOrderUsingPostData>>) => {
    const mutationOptions: UseMutationOptions<PayPointMarketOrderUsingPostResponse, DefaultError, Options<PayPointMarketOrderUsingPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHpointDASHmarketSLASHorderSLASHpayments({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHpointDASHmarketSLASHorderSLASHpreviewQueryKey = (options: Options<GetPointMarketOrderPreviewUsingGetData>) => createQueryKey('getPointMarketOrderPreviewUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHpointDASHmarketSLASHorderSLASHpreviewOptions = (options: Options<GetPointMarketOrderPreviewUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHpointDASHmarketSLASHorderSLASHpreview({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHpointDASHmarketSLASHorderSLASHpreviewQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHpointDASHmarketSLASHorderSLASHreissueDASHcouponQueryKey = (options?: Options<ReissueCouponUsingPostData>) => createQueryKey('reissueCouponUsingPost', options);

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHpointDASHmarketSLASHorderSLASHreissueDASHcouponOptions = (options?: Options<ReissueCouponUsingPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHpointDASHmarketSLASHorderSLASHreissueDASHcoupon({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postMETHODSLASHwelloSLASHv2SLASHauthSLASHpointDASHmarketSLASHorderSLASHreissueDASHcouponQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHpointDASHmarketSLASHorderSLASHreissueDASHcouponMutation = (options?: Partial<Options<ReissueCouponUsingPostData>>) => {
    const mutationOptions: UseMutationOptions<ReissueCouponUsingPostResponse, DefaultError, Options<ReissueCouponUsingPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHpointDASHmarketSLASHorderSLASHreissueDASHcoupon({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHpointDASHmarketSLASHproductSLASHavailDASHpointDASHproductQueryKey = (options?: Options<GetAvailablePointProductListUsingGetData>) => createQueryKey('getAvailablePointProductListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHpointDASHmarketSLASHproductSLASHavailDASHpointDASHproductOptions = (options?: Options<GetAvailablePointProductListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHpointDASHmarketSLASHproductSLASHavailDASHpointDASHproduct({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHpointDASHmarketSLASHproductSLASHavailDASHpointDASHproductQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHpointDASHmarketSLASHproductSLASHavailDASHpointDASHproductInfiniteQueryKey = (options?: Options<GetAvailablePointProductListUsingGetData>): QueryKey<Options<GetAvailablePointProductListUsingGetData>> => createQueryKey('getAvailablePointProductListUsingGet', options, true);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHpointDASHmarketSLASHproductSLASHavailDASHpointDASHproductInfiniteOptions = (options?: Options<GetAvailablePointProductListUsingGetData>) => {
    return infiniteQueryOptions<GetAvailablePointProductListUsingGetResponse, DefaultError, InfiniteData<GetAvailablePointProductListUsingGetResponse>, QueryKey<Options<GetAvailablePointProductListUsingGetData>>, number | Pick<QueryKey<Options<GetAvailablePointProductListUsingGetData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetAvailablePointProductListUsingGetData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHpointDASHmarketSLASHproductSLASHavailDASHpointDASHproduct({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHpointDASHmarketSLASHproductSLASHavailDASHpointDASHproductInfiniteQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHpointDASHmarketSLASHproductSLASHLBRACEproductUNDERSCOREidUNDERSCOREidxRBRACESLASHfeedbackQueryKey = (options: Options<FeedbackPointMarketProductUsingPostData>) => createQueryKey('feedbackPointMarketProductUsingPost', options);

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHpointDASHmarketSLASHproductSLASHLBRACEproductUNDERSCOREidUNDERSCOREidxRBRACESLASHfeedbackOptions = (options: Options<FeedbackPointMarketProductUsingPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHpointDASHmarketSLASHproductSLASHLBRACEproductUNDERSCOREidUNDERSCOREidxRBRACESLASHfeedback({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postMETHODSLASHwelloSLASHv2SLASHauthSLASHpointDASHmarketSLASHproductSLASHLBRACEproductUNDERSCOREidUNDERSCOREidxRBRACESLASHfeedbackQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHpointDASHmarketSLASHproductSLASHLBRACEproductUNDERSCOREidUNDERSCOREidxRBRACESLASHfeedbackMutation = (options?: Partial<Options<FeedbackPointMarketProductUsingPostData>>) => {
    const mutationOptions: UseMutationOptions<FeedbackPointMarketProductUsingPostResponse, DefaultError, Options<FeedbackPointMarketProductUsingPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHpointDASHmarketSLASHproductSLASHLBRACEproductUNDERSCOREidUNDERSCOREidxRBRACESLASHfeedback({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHrandomDASHticketQueryKey = (options: Options<GetRandomTicketListUsingGetData>) => createQueryKey('getRandomTicketListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHrandomDASHticketOptions = (options: Options<GetRandomTicketListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHrandomDASHticket({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHrandomDASHticketQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHrandomDASHticketInfiniteQueryKey = (options: Options<GetRandomTicketListUsingGetData>): QueryKey<Options<GetRandomTicketListUsingGetData>> => createQueryKey('getRandomTicketListUsingGet', options, true);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHrandomDASHticketInfiniteOptions = (options: Options<GetRandomTicketListUsingGetData>) => {
    return infiniteQueryOptions<GetRandomTicketListUsingGetResponse, DefaultError, InfiniteData<GetRandomTicketListUsingGetResponse>, QueryKey<Options<GetRandomTicketListUsingGetData>>, number | Pick<QueryKey<Options<GetRandomTicketListUsingGetData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetRandomTicketListUsingGetData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHrandomDASHticket({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHrandomDASHticketInfiniteQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHrandomDASHticketSLASHLBRACErandomUNDERSCOREticketUNDERSCOREidRBRACEQueryKey = (options: Options<GetRandomTicketUsingGetData>) => createQueryKey('getRandomTicketUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHrandomDASHticketSLASHLBRACErandomUNDERSCOREticketUNDERSCOREidRBRACEOptions = (options: Options<GetRandomTicketUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHrandomDASHticketSLASHLBRACErandomUNDERSCOREticketUNDERSCOREidRBRACE({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHrandomDASHticketSLASHLBRACErandomUNDERSCOREticketUNDERSCOREidRBRACEQueryKey(options)
    });
};

export const putMETHODSLASHwelloSLASHv2SLASHauthSLASHrandomDASHticketSLASHLBRACErandomUNDERSCOREticketUNDERSCOREidRBRACESLASHopenMutation = (options?: Partial<Options<OpenRandomTicketUsingPutData>>) => {
    const mutationOptions: UseMutationOptions<OpenRandomTicketUsingPutResponse, DefaultError, Options<OpenRandomTicketUsingPutData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await putMETHODSLASHwelloSLASHv2SLASHauthSLASHrandomDASHticketSLASHLBRACErandomUNDERSCOREticketUNDERSCOREidRBRACESLASHopen({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const putMETHODSLASHwelloSLASHv2SLASHauthSLASHrandomDASHticketSLASHLBRACErandomUNDERSCOREticketUNDERSCOREidRBRACESLASHreviewMutation = (options?: Partial<Options<ReviewRandomTicketUsingPutData>>) => {
    const mutationOptions: UseMutationOptions<ReviewRandomTicketUsingPutResponse, DefaultError, Options<ReviewRandomTicketUsingPutData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await putMETHODSLASHwelloSLASHv2SLASHauthSLASHrandomDASHticketSLASHLBRACErandomUNDERSCOREticketUNDERSCOREidRBRACESLASHreview({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const deleteMETHODSLASHwelloSLASHv2SLASHauthSLASHs3Mutation = (options?: Partial<Options<FileDeleteUsingDeleteData>>) => {
    const mutationOptions: UseMutationOptions<FileDeleteUsingDeleteResponse, DefaultError, Options<FileDeleteUsingDeleteData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await deleteMETHODSLASHwelloSLASHv2SLASHauthSLASHs3({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHs3QueryKey = (options?: Options<FileUploadUsingPost1Data>) => createQueryKey('fileUploadUsingPost1', options);

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHs3Options = (options?: Options<FileUploadUsingPost1Data>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHs3({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postMETHODSLASHwelloSLASHv2SLASHauthSLASHs3QueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHs3Mutation = (options?: Partial<Options<FileUploadUsingPost1Data>>) => {
    const mutationOptions: UseMutationOptions<FileUploadUsingPost1Response, DefaultError, Options<FileUploadUsingPost1Data>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHs3({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const putMETHODSLASHwelloSLASHv2SLASHauthSLASHs3Mutation = (options?: Partial<Options<UpdateFileTempSaveYnUsingPutData>>) => {
    const mutationOptions: UseMutationOptions<UpdateFileTempSaveYnUsingPutResponse, DefaultError, Options<UpdateFileTempSaveYnUsingPutData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await putMETHODSLASHwelloSLASHv2SLASHauthSLASHs3({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHs3SLASHcopyQueryKey = (options?: Options<FileCopyUsingPostData>) => createQueryKey('fileCopyUsingPost', options);

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHs3SLASHcopyOptions = (options?: Options<FileCopyUsingPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHs3SLASHcopy({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postMETHODSLASHwelloSLASHv2SLASHauthSLASHs3SLASHcopyQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHs3SLASHcopyMutation = (options?: Partial<Options<FileCopyUsingPostData>>) => {
    const mutationOptions: UseMutationOptions<FileCopyUsingPostResponse, DefaultError, Options<FileCopyUsingPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHs3SLASHcopy({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHs3SLASHdecryptionQueryKey = (options: Options<FileDecryptionDownloadUsingGetData>) => createQueryKey('fileDecryptionDownloadUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHs3SLASHdecryptionOptions = (options: Options<FileDecryptionDownloadUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHs3SLASHdecryption({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHs3SLASHdecryptionQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHs3SLASHreQueryKey = (options?: Options<FileReUploadUsingPostData>) => createQueryKey('fileReUploadUsingPost', options);

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHs3SLASHreOptions = (options?: Options<FileReUploadUsingPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHs3SLASHre({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postMETHODSLASHwelloSLASHv2SLASHauthSLASHs3SLASHreQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHs3SLASHreMutation = (options?: Partial<Options<FileReUploadUsingPostData>>) => {
    const mutationOptions: UseMutationOptions<FileReUploadUsingPostResponse, DefaultError, Options<FileReUploadUsingPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHs3SLASHre({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const putMETHODSLASHwelloSLASHv2SLASHauthSLASHs3SLASHrenameMutation = (options?: Partial<Options<FileRenameUsingPutData>>) => {
    const mutationOptions: UseMutationOptions<FileRenameUsingPutResponse, DefaultError, Options<FileRenameUsingPutData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await putMETHODSLASHwelloSLASHv2SLASHauthSLASHs3SLASHrename({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcontentsSLASHsituationQueryKey = (options?: Options<SituationListUsingGetData>) => createQueryKey('situationListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcontentsSLASHsituationOptions = (options?: Options<SituationListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHcontentsSLASHsituation({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHcontentsSLASHsituationQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcontentsSLASHsituationSLASHLBRACEsituationUNDERSCOREidRBRACEQueryKey = (options: Options<GetSituationPolicyListUsingGetData>) => createQueryKey('getSituationPolicyListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcontentsSLASHsituationSLASHLBRACEsituationUNDERSCOREidRBRACEOptions = (options: Options<GetSituationPolicyListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHcontentsSLASHsituationSLASHLBRACEsituationUNDERSCOREidRBRACE({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHcontentsSLASHsituationSLASHLBRACEsituationUNDERSCOREidRBRACEQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHappDASHpushQueryKey = (options: Options<GetWebWelloAppPushListUsingGetData>) => createQueryKey('getWebWelloAppPushListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHappDASHpushOptions = (options: Options<GetWebWelloAppPushListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHappDASHpush({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHappDASHpushQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHappDASHpushInfiniteQueryKey = (options: Options<GetWebWelloAppPushListUsingGetData>): QueryKey<Options<GetWebWelloAppPushListUsingGetData>> => createQueryKey('getWebWelloAppPushListUsingGet', options, true);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHappDASHpushInfiniteOptions = (options: Options<GetWebWelloAppPushListUsingGetData>) => {
    return infiniteQueryOptions<GetWebWelloAppPushListUsingGetResponse, DefaultError, InfiniteData<GetWebWelloAppPushListUsingGetResponse>, QueryKey<Options<GetWebWelloAppPushListUsingGetData>>, number | Pick<QueryKey<Options<GetWebWelloAppPushListUsingGetData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetWebWelloAppPushListUsingGetData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHappDASHpush({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHappDASHpushInfiniteQueryKey(options)
    });
};

export const putMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHappDASHpushMutation = (options?: Partial<Options<UpdateWelloAppPushReadUsingPutData>>) => {
    const mutationOptions: UseMutationOptions<UpdateWelloAppPushReadUsingPutResponse, DefaultError, Options<UpdateWelloAppPushReadUsingPutData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await putMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHappDASHpush({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHapplyDASHpolicyQueryKey = (options?: Options<GetWelloApplyPolicyListUsingGetData>) => createQueryKey('getWelloApplyPolicyListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHapplyDASHpolicyOptions = (options?: Options<GetWelloApplyPolicyListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHapplyDASHpolicy({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHapplyDASHpolicyQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHcommentQueryKey = (options: Options<GetWelloCommentListUsingGetData>) => createQueryKey('getWelloCommentListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHcommentOptions = (options: Options<GetWelloCommentListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHcomment({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHcommentQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHcommentInfiniteQueryKey = (options: Options<GetWelloCommentListUsingGetData>): QueryKey<Options<GetWelloCommentListUsingGetData>> => createQueryKey('getWelloCommentListUsingGet', options, true);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHcommentInfiniteOptions = (options: Options<GetWelloCommentListUsingGetData>) => {
    return infiniteQueryOptions<GetWelloCommentListUsingGetResponse, DefaultError, InfiniteData<GetWelloCommentListUsingGetResponse>, QueryKey<Options<GetWelloCommentListUsingGetData>>, number | Pick<QueryKey<Options<GetWelloCommentListUsingGetData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetWelloCommentListUsingGetData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHcomment({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHcommentInfiniteQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHcommentQueryKey = (options?: Options<SaveWelloCommentUsingPostData>) => createQueryKey('saveWelloCommentUsingPost', options);

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHcommentOptions = (options?: Options<SaveWelloCommentUsingPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHcomment({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHcommentQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHcommentMutation = (options?: Partial<Options<SaveWelloCommentUsingPostData>>) => {
    const mutationOptions: UseMutationOptions<SaveWelloCommentUsingPostResponse, DefaultError, Options<SaveWelloCommentUsingPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHcomment({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHcommentSLASHliveQueryKey = (options?: Options<GetLiveWelloCommentListUsingGetData>) => createQueryKey('getLiveWelloCommentListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHcommentSLASHliveOptions = (options?: Options<GetLiveWelloCommentListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHcommentSLASHlive({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHcommentSLASHliveQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHcommentSLASHmyQueryKey = (options: Options<GetMyWelloCommentListUsingGetData>) => createQueryKey('getMyWelloCommentListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHcommentSLASHmyOptions = (options: Options<GetMyWelloCommentListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHcommentSLASHmy({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHcommentSLASHmyQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHcommentSLASHmyInfiniteQueryKey = (options: Options<GetMyWelloCommentListUsingGetData>): QueryKey<Options<GetMyWelloCommentListUsingGetData>> => createQueryKey('getMyWelloCommentListUsingGet', options, true);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHcommentSLASHmyInfiniteOptions = (options: Options<GetMyWelloCommentListUsingGetData>) => {
    return infiniteQueryOptions<GetMyWelloCommentListUsingGetResponse, DefaultError, InfiniteData<GetMyWelloCommentListUsingGetResponse>, QueryKey<Options<GetMyWelloCommentListUsingGetData>>, number | Pick<QueryKey<Options<GetMyWelloCommentListUsingGetData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetMyWelloCommentListUsingGetData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHcommentSLASHmy({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHcommentSLASHmyInfiniteQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHcommentSLASHLBRACEwelloCommentIdRBRACEQueryKey = (options: Options<GetMetaPolicyCommentListUsingGetData>) => createQueryKey('getMetaPolicyCommentListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHcommentSLASHLBRACEwelloCommentIdRBRACEOptions = (options: Options<GetMetaPolicyCommentListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHcommentSLASHLBRACEwelloCommentIdRBRACE({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHcommentSLASHLBRACEwelloCommentIdRBRACEQueryKey(options)
    });
};

export const putMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHcommentSLASHLBRACEwelloUNDERSCOREcommentUNDERSCOREidRBRACEMutation = (options?: Partial<Options<UpdateWelloCommentUsingPutData>>) => {
    const mutationOptions: UseMutationOptions<UpdateWelloCommentUsingPutResponse, DefaultError, Options<UpdateWelloCommentUsingPutData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await putMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHcommentSLASHLBRACEwelloUNDERSCOREcommentUNDERSCOREidRBRACE({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const putMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHcommentSLASHLBRACEwelloUNDERSCOREcommentUNDERSCOREidRBRACESLASHdeleteMutation = (options?: Partial<Options<DeleteWelloCommentUsingPutData>>) => {
    const mutationOptions: UseMutationOptions<DeleteWelloCommentUsingPutResponse, DefaultError, Options<DeleteWelloCommentUsingPutData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await putMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHcommentSLASHLBRACEwelloUNDERSCOREcommentUNDERSCOREidRBRACESLASHdelete({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHcommentDASHreportQueryKey = (options?: Options<SaveWelloCommentReportUsingPostData>) => createQueryKey('saveWelloCommentReportUsingPost', options);

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHcommentDASHreportOptions = (options?: Options<SaveWelloCommentReportUsingPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHcommentDASHreport({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHcommentDASHreportQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHcommentDASHreportMutation = (options?: Partial<Options<SaveWelloCommentReportUsingPostData>>) => {
    const mutationOptions: UseMutationOptions<SaveWelloCommentReportUsingPostResponse, DefaultError, Options<SaveWelloCommentReportUsingPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHcommentDASHreport({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHdeviceDASHinfoQueryKey = (options?: Options<SaveWelloDeviceInfoUsingPostData>) => createQueryKey('saveWelloDeviceInfoUsingPost', options);

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHdeviceDASHinfoOptions = (options?: Options<SaveWelloDeviceInfoUsingPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHdeviceDASHinfo({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHdeviceDASHinfoQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHdeviceDASHinfoMutation = (options?: Partial<Options<SaveWelloDeviceInfoUsingPostData>>) => {
    const mutationOptions: UseMutationOptions<SaveWelloDeviceInfoUsingPostResponse, DefaultError, Options<SaveWelloDeviceInfoUsingPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHdeviceDASHinfo({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHhelperQueryKey = (options?: Options<SaveWelloHelperUsingPostData>) => createQueryKey('saveWelloHelperUsingPost', options);

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHhelperOptions = (options?: Options<SaveWelloHelperUsingPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHhelper({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHhelperQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHhelperMutation = (options?: Partial<Options<SaveWelloHelperUsingPostData>>) => {
    const mutationOptions: UseMutationOptions<SaveWelloHelperUsingPostResponse, DefaultError, Options<SaveWelloHelperUsingPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHhelper({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const deleteMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHlikeMutation = (options?: Partial<Options<DeleteWelloLikeUsingDeleteData>>) => {
    const mutationOptions: UseMutationOptions<DeleteWelloLikeUsingDeleteResponse, DefaultError, Options<DeleteWelloLikeUsingDeleteData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await deleteMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHlike({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHlikeQueryKey = (options?: Options<SaveWelloLikeUsingPostData>) => createQueryKey('saveWelloLikeUsingPost', options);

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHlikeOptions = (options?: Options<SaveWelloLikeUsingPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHlike({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHlikeQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHlikeMutation = (options?: Partial<Options<SaveWelloLikeUsingPostData>>) => {
    const mutationOptions: UseMutationOptions<SaveWelloLikeUsingPostResponse, DefaultError, Options<SaveWelloLikeUsingPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHlike({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHlikeSLASHmyQueryKey = (options: Options<GetListLikeContentsUsingGetData>) => createQueryKey('getListLikeContentsUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHlikeSLASHmyOptions = (options: Options<GetListLikeContentsUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHlikeSLASHmy({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHlikeSLASHmyQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHlikeSLASHmyInfiniteQueryKey = (options: Options<GetListLikeContentsUsingGetData>): QueryKey<Options<GetListLikeContentsUsingGetData>> => createQueryKey('getListLikeContentsUsingGet', options, true);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHlikeSLASHmyInfiniteOptions = (options: Options<GetListLikeContentsUsingGetData>) => {
    return infiniteQueryOptions<GetListLikeContentsUsingGetResponse, DefaultError, InfiniteData<GetListLikeContentsUsingGetResponse>, QueryKey<Options<GetListLikeContentsUsingGetData>>, number | Pick<QueryKey<Options<GetListLikeContentsUsingGetData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetListLikeContentsUsingGetData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHlikeSLASHmy({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHlikeSLASHmyInfiniteQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHlikeSLASHmySLASHtypeQueryKey = (options?: Options<GetListLikeContentsTypeUsingGetData>) => createQueryKey('getListLikeContentsTypeUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHlikeSLASHmySLASHtypeOptions = (options?: Options<GetListLikeContentsTypeUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHlikeSLASHmySLASHtype({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHlikeSLASHmySLASHtypeQueryKey(options)
    });
};

export const deleteMETHODSLASHwelloSLASHv2SLASHauthSLASHfamilyMutation = (options?: Partial<Options<DeleteWelloMemberFamilyUsingDeleteData>>) => {
    const mutationOptions: UseMutationOptions<DeleteWelloMemberFamilyUsingDeleteResponse, DefaultError, Options<DeleteWelloMemberFamilyUsingDeleteData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await deleteMETHODSLASHwelloSLASHv2SLASHauthSLASHfamily({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHfamilySLASHprofileQueryKey = (options?: Options<GetWelloMemberFamilyUsingGetData>) => createQueryKey('getWelloMemberFamilyUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHfamilySLASHprofileOptions = (options?: Options<GetWelloMemberFamilyUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHfamilySLASHprofile({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHfamilySLASHprofileQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHfamilySLASHprofileQueryKey = (options?: Options<SaveWelloMemberFamilyUsingPostData>) => createQueryKey('saveWelloMemberFamilyUsingPost', options);

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHfamilySLASHprofileOptions = (options?: Options<SaveWelloMemberFamilyUsingPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHfamilySLASHprofile({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postMETHODSLASHwelloSLASHv2SLASHauthSLASHfamilySLASHprofileQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHfamilySLASHprofileMutation = (options?: Partial<Options<SaveWelloMemberFamilyUsingPostData>>) => {
    const mutationOptions: UseMutationOptions<SaveWelloMemberFamilyUsingPostResponse, DefaultError, Options<SaveWelloMemberFamilyUsingPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHfamilySLASHprofile({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const putMETHODSLASHwelloSLASHv2SLASHauthSLASHfamilySLASHprofileMutation = (options?: Partial<Options<UpdateWelloMemberFamilyUsingPutData>>) => {
    const mutationOptions: UseMutationOptions<UpdateWelloMemberFamilyUsingPutResponse, DefaultError, Options<UpdateWelloMemberFamilyUsingPutData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await putMETHODSLASHwelloSLASHv2SLASHauthSLASHfamilySLASHprofile({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHeventDASHparticipationQueryKey = (options?: Options<SaveWelloParticipationUsingPostData>) => createQueryKey('saveWelloParticipationUsingPost', options);

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHeventDASHparticipationOptions = (options?: Options<SaveWelloParticipationUsingPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHeventDASHparticipation({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHeventDASHparticipationQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHeventDASHparticipationMutation = (options?: Partial<Options<SaveWelloParticipationUsingPostData>>) => {
    const mutationOptions: UseMutationOptions<SaveWelloParticipationUsingPostResponse, DefaultError, Options<SaveWelloParticipationUsingPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHeventDASHparticipation({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcontentsSLASHpickQueryKey = (options?: Options<WelloPickListUsingGetData>) => createQueryKey('welloPickListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcontentsSLASHpickOptions = (options?: Options<WelloPickListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHcontentsSLASHpick({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHcontentsSLASHpickQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcontentsSLASHpickSLASHLBRACEwelloUNDERSCOREpickUNDERSCOREidRBRACEQueryKey = (options: Options<WelloPickPolicyListUsingGetData>) => createQueryKey('welloPickPolicyListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHcontentsSLASHpickSLASHLBRACEwelloUNDERSCOREpickUNDERSCOREidRBRACEOptions = (options: Options<WelloPickPolicyListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHcontentsSLASHpickSLASHLBRACEwelloUNDERSCOREpickUNDERSCOREidRBRACE({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHcontentsSLASHpickSLASHLBRACEwelloUNDERSCOREpickUNDERSCOREidRBRACEQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicyDASHapplySLASHcheckQueryKey = (options: Options<CheckWelloPolicyApplyUsingGetData>) => createQueryKey('checkWelloPolicyApplyUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicyDASHapplySLASHcheckOptions = (options: Options<CheckWelloPolicyApplyUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicyDASHapplySLASHcheck({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicyDASHapplySLASHcheckQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicyDASHapplySLASHhistoryQueryKey = (options?: Options<GetWelloPolicyApplyListUsingGetData>) => createQueryKey('getWelloPolicyApplyListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicyDASHapplySLASHhistoryOptions = (options?: Options<GetWelloPolicyApplyListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicyDASHapplySLASHhistory({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicyDASHapplySLASHhistoryQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicyDASHapplySLASHhistorySLASHcountQueryKey = (options?: Options<GetWelloPolicyApplyCountUsingGetData>) => createQueryKey('getWelloPolicyApplyCountUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicyDASHapplySLASHhistorySLASHcountOptions = (options?: Options<GetWelloPolicyApplyCountUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicyDASHapplySLASHhistorySLASHcount({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicyDASHapplySLASHhistorySLASHcountQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicyDASHapplySLASHreportQueryKey = (options: Options<SaveReportUsingPostData>) => createQueryKey('saveReportUsingPost', options);

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicyDASHapplySLASHreportOptions = (options: Options<SaveReportUsingPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicyDASHapplySLASHreport({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicyDASHapplySLASHreportQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicyDASHapplySLASHreportMutation = (options?: Partial<Options<SaveReportUsingPostData>>) => {
    const mutationOptions: UseMutationOptions<SaveReportUsingPostResponse, DefaultError, Options<SaveReportUsingPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHpolicyDASHapplySLASHreport({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHtrackQueryKey = (options?: Options<SaveWelloTrackingUsingPostData>) => createQueryKey('saveWelloTrackingUsingPost', options);

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHtrackOptions = (options?: Options<SaveWelloTrackingUsingPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHtrack({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHtrackQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHtrackMutation = (options?: Partial<Options<SaveWelloTrackingUsingPostData>>) => {
    const mutationOptions: UseMutationOptions<SaveWelloTrackingUsingPostResponse, DefaultError, Options<SaveWelloTrackingUsingPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHwelloDASHtrack({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const deleteMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHwishlistMutation = (options?: Partial<Options<DeleteWishlistUsingDeleteData>>) => {
    const mutationOptions: UseMutationOptions<DeleteWishlistUsingDeleteResponse, DefaultError, Options<DeleteWishlistUsingDeleteData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await deleteMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHwishlist({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHwishlistQueryKey = (options?: Options<SaveWishlistUsingPost1Data>) => createQueryKey('saveWishlistUsingPost1', options);

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHwishlistOptions = (options?: Options<SaveWishlistUsingPost1Data>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHwishlist({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHwishlistQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHwishlistMutation = (options?: Partial<Options<SaveWishlistUsingPost1Data>>) => {
    const mutationOptions: UseMutationOptions<SaveWishlistUsingPost1Response, DefaultError, Options<SaveWishlistUsingPost1Data>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHwishlist({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHwishlistSLASHbestDASHcontentsQueryKey = (options?: Options<BestContentsWishlistUsingGetData>) => createQueryKey('bestContentsWishlistUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHwishlistSLASHbestDASHcontentsOptions = (options?: Options<BestContentsWishlistUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHwishlistSLASHbestDASHcontents({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHwishlistSLASHbestDASHcontentsQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHwishlistSLASHcommunityQueryKey = (options?: Options<GetCommunityWishlistUsingGetData>) => createQueryKey('getCommunityWishlistUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHwishlistSLASHcommunityOptions = (options?: Options<GetCommunityWishlistUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHwishlistSLASHcommunity({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHwishlistSLASHcommunityQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHwishlistSLASHcommunitySLASHpolicyDASHtalkQueryKey = (options?: Options<GetCommunityPolicyTalkWishlistUsingGetData>) => createQueryKey('getCommunityPolicyTalkWishlistUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHwishlistSLASHcommunitySLASHpolicyDASHtalkOptions = (options?: Options<GetCommunityPolicyTalkWishlistUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHwishlistSLASHcommunitySLASHpolicyDASHtalk({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHwishlistSLASHcommunitySLASHpolicyDASHtalkQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHwishlistSLASHcommunitySLASHwelloDASHnewsQueryKey = (options?: Options<GetCommunityWelloNewsWishlistUsingGetData>) => createQueryKey('getCommunityWelloNewsWishlistUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHwishlistSLASHcommunitySLASHwelloDASHnewsOptions = (options?: Options<GetCommunityWelloNewsWishlistUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHwishlistSLASHcommunitySLASHwelloDASHnews({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHwishlistSLASHcommunitySLASHwelloDASHnewsQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHwishlistSLASHemergencyDASHroomQueryKey = (options?: Options<GetEmergencyRoomWishlistUsingGetData>) => createQueryKey('getEmergencyRoomWishlistUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHwishlistSLASHemergencyDASHroomOptions = (options?: Options<GetEmergencyRoomWishlistUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHwishlistSLASHemergencyDASHroom({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHwishlistSLASHemergencyDASHroomQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHwishlistSLASHhometownDASHnewsQueryKey = (options?: Options<HometownNewsWishlistUsingGetData>) => createQueryKey('hometownNewsWishlistUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHwishlistSLASHhometownDASHnewsOptions = (options?: Options<HometownNewsWishlistUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHwishlistSLASHhometownDASHnews({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHwishlistSLASHhometownDASHnewsQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHwishlistSLASHpolicyQueryKey = (options?: Options<MetaPolicyWishlistUsingGetData>) => createQueryKey('metaPolicyWishlistUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHwishlistSLASHpolicyOptions = (options?: Options<MetaPolicyWishlistUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHwishlistSLASHpolicy({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHwishlistSLASHpolicyQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHwishlistSLASHvoucherDASHproviderQueryKey = (options?: Options<VoucherProviderWishlistUsingGetData>) => createQueryKey('voucherProviderWishlistUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHwishlistSLASHvoucherDASHproviderOptions = (options?: Options<VoucherProviderWishlistUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHwishlistSLASHvoucherDASHprovider({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHauthSLASHmemberSLASHwishlistSLASHvoucherDASHproviderQueryKey(options)
    });
};